export const translations = {
  ar: {
    appName: "ProfitLens",
    tagline: "اعرف ربحك الحقيقي",
    navDashboard: "لوحة التحكم",
    navProducts: "المنتجات",
    navAddProduct: "إضافة منتج",
    navReports: "التقارير",
    navSettings: "الإعدادات",
    logout: "تسجيل الخروج",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    name: "الاسم",
    namePh: "مثال: ربيع الصفراج",
    email: "البريد الإلكتروني",
    emailPh: "you@example.com",
    password: "كلمة المرور",
    passwordPh: "٦ أحرف على الأقل",
    loginTitle: "مرحبًا بعودتك",
    loginSubtitle: "سجّل الدخول لمتابعة أرباح منتجاتك",
    registerTitle: "أنشئ حسابك مجانًا",
    registerSubtitle: "ابدأ بمعرفة ربحك الحقيقي في دقائق",
    noAccount: "ليس لديك حساب؟",
    haveAccount: "لديك حساب بالفعل؟",
    orDivider: "أو تابع باستخدام",
    googleBtn: "المتابعة بحساب Google",
    somethingWrong: "حدث خطأ ما. حاول مرة أخرى.",
    sessionExpired: "انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.",
    welcome: "أهلًا بك",
    dashboardTitle: "لوحة التحكم",
    dashboardSubtitle: "نظرة شاملة على أداء أرباحك",
    totalSales: "إجمالي المبيعات",
    productCosts: "تكاليف المنتجات",
    additionalCosts: "التكاليف الإضافية",
    netProfit: "صافي الربح",
    profitMargin: "هامش الربح",
    profitByProduct: "صافي الربح حسب المنتج",
    costSplit: "توزيع الإيرادات",
    legendNetProfit: "صافي الربح",
    legendProductCosts: "تكاليف المنتجات",
    legendAdditionalCosts: "تكاليف إضافية",
    topProfitable: "الأكثر ربحية",
    lowestMargin: "أدنى هامش ربح",
    volumeLowMargin: "مبيعات عالية · ربح ضعيف",
    insightsTitle: "رؤى ذكية",
    noInsights: "لا توجد تنبيهات حاليًا. أداء منتجاتك جيد.",
    insightNegative: "أنت تخسر المال على {name}. راجع التكاليف أو السعر فورًا.",
    insightLow: "هامش ربح {name} منخفض جدًا (أقل من 10%).",
    insightStrong: "{name} من أقوى منتجاتك (هامش يتجاوز 40%).",
    insightVolume: "{name} يبيع جيدًا لكنه يحقق ربحًا ضعيفًا.",
    demoActive: "بيانات تجريبية مفعّلة",
    demoActiveDesc: "هذه منتجات عينة لاستكشاف ProfitLens. يمكنك حذفها في أي وقت.",
    clearDemo: "حذف البيانات التجريبية",
    loadDemo: "تحميل بيانات تجريبية",
    emptyTitle: "لا توجد منتجات بعد",
    emptyDesc: "أضف أول منتج لك أو جرّب البيانات التجريبية لترى كيف يعمل ProfitLens.",
    addFirst: "أضف أول منتج",
    productsTitle: "المنتجات",
    productsSubtitle: "إدارة منتجاتك وتتبع ربحية كل منها",
    searchPlaceholder: "ابحث بالاسم أو SKU...",
    filterAll: "كل المنتجات",
    filterProfitable: "الرابحة",
    filterLowMargin: "هامش منخفض (<10%)",
    filterLosing: "الخاسرة",
    sortProfitHigh: "الربح: من الأعلى",
    sortProfitLow: "الربح: من الأدنى",
    sortMarginHigh: "الهامش: من الأعلى",
    sortQtyHigh: "الكمية: من الأعلى",
    sortName: "الاسم أ-ي",
    thProduct: "المنتج",
    thPrice: "السعر",
    thUnitCost: "تكلفة الوحدة",
    thQty: "المباع",
    thNetProfit: "صافي الربح",
    thMargin: "الهامش",
    edit: "تعديل",
    delete: "حذف",
    deleteTitle: "حذف المنتج؟",
    deleteDesc: "سيتم حذف هذا المنتج نهائيًا ولا يمكن التراجع.",
    cancel: "إلغاء",
    confirmDelete: "نعم، احذف",
    noResults: "لا توجد نتائج مطابقة",
    demoBadge: "تجريبي",
    productDeleted: "تم حذف المنتج",
    addProductTitle: "إضافة منتج",
    editProductTitle: "تعديل المنتج",
    formSubtitle: "أدخل السعر والتكاليف وسنحسب الربح فورًا",
    fName: "اسم المنتج",
    fNamePh: "مثال: سماعات لاسلكية برو",
    fSku: "SKU (اختياري)",
    fSkuPh: "مثال: EAR-001",
    fPrice: "سعر البيع",
    fCost: "تكلفة الشراء/المنتج",
    fCurrency: "العملة",
    fCurrencyNone: "بدون تحديد",
    fSpec: "الكمية / المواصفة",
    fSpecQty: "الكمية",
    fSpecUnit: "الوحدة",
    fSpecNone: "بدون تحديد",
    fSpecCustom: "وحدة مخصصة…",
    fSpecCustomPh: "اكتب اسم الوحدة",
    specHint: "معلومات للعرض فقط — لا تؤثر على المخزون إطلاقًا",
    navAccounts: "دليل الحسابات",
    accountsSubtitle: "الهيكل المحاسبي الأساسي لحسابات منشأتك",
    addAccount: "إضافة حساب",
    editAccount: "تعديل الحساب",
    accountCode: "رقم الحساب",
    accountName: "اسم الحساب",
    accountType: "نوع الحساب",
    parentAccount: "الحساب الأب",
    noParent: "بدون (حساب رئيسي)",
    accountSubgroup: "المجموعة الفرعية",
    noSubgroup: "بدون",
    accountNature: "طبيعة الحساب",
    natureDebit: "مدين",
    natureCredit: "دائن",
    accountStatusLabel: "الحالة",
    statusActive: "نشط",
    statusInactive: "غير نشط",
    acctActivate: "تفعيل",
    acctDeactivate: "إيقاف",
    searchAccounts: "بحث برقم أو اسم الحساب…",
    accountCreated: "تم إنشاء الحساب",
    accountUpdated: "تم تحديث الحساب",
    accountDeleted: "تم حذف الحساب",
    systemAccountNote: "حساب افتراضي — يمكن تفعيله أو إيقافه فقط",
    deleteAccountConfirm: "سيتم حذف هذا الحساب نهائيًا. الحسابات المرتبطة بقيود أو حسابات فرعية لا يمكن حذفها.",
    acctGroup_assets: "الأصول",
    acctGroup_liabilities: "الالتزامات",
    acctGroup_equity: "حقوق الملكية",
    acctGroup_revenue: "الإيرادات",
    acctGroup_cost_of_sales: "تكلفة المبيعات",
    navLedger: "القيود والقوائم",
    ledgerTitle: "القيود والقوائم المالية",
    ledgerSubtitle: "دفتر القيود والقوائم المالية المستمدة مباشرة من القيود المحاسبية",
    tabJournal: "دفتر القيود",
    tabTrialBalance: "ميزان المراجعة",
    tabIncome: "قائمة الدخل",
    tabBalanceSheet: "الميزانية العمومية",
    colRef: "رقم القيد",
    colType: "نوع العملية",
    colAccount: "الحساب",
    colDebit: "مدين",
    colCredit: "دائن",
    colDesc: "البيان",
    srcSale: "مبيعات",
    srcPurchase: "مشتريات",
    srcExpense: "مصروف",
    srcReturn: "مرتجع",
    kindPosted: "مرحّل",
    kindReversal: "قيد عكسي",
    backfilledTag: "قيد تاريخي",
    searchJournal: "ابحث برقم القيد أو البيان أو الحساب...",
    allTypes: "كل الأنواع",
    colCode: "رمز الحساب",
    colDebitTotal: "إجمالي المدين",
    colCreditTotal: "إجمالي الدائن",
    colNetBalance: "الرصيد",
    tbTotals: "الإجمالي",
    balancedTag: "متوازن",
    unbalancedTag: "غير متوازن",
    isRevenueSection: "إيرادات المبيعات",
    isLessCogs: "(-) تكلفة البضاعة المباعة",
    isGrossProfit: "= مجمل الربح",
    isLessExpenses: "(-) المصاريف التشغيلية",
    isNetIncome: "= صافي الربح / الخسارة",
    bsCurrentAssets: "الأصول المتداولة",
    bsNonCurrentAssets: "الأصول غير المتداولة",
    bsLiabilitiesSection: "الالتزامات",
    bsEquitySection: "حقوق الملكية",
    bsCurrentEarnings: "صافي ربح الفترة",
    bsTotalAssets: "إجمالي الأصول",
    bsTotalLE: "إجمالي الالتزامات وحقوق الملكية",
    bsEquationOk: "الأصول = الالتزامات + حقوق الملكية",
    bsEquationBad: "المعادلة المحاسبية غير متوازنة",
    fromDate: "من تاريخ",
    toDate: "إلى تاريخ",
    noJournalEntries: "لا توجد قيود بعد",
    forgotLink: "نسيت كلمة المرور؟",
    forgotTitle: "استعادة كلمة المرور",
    forgotDesc: "أدخل بريدك الإلكتروني المسجّل وسنرسل لك رابط إعادة التعيين",
    forgotSubmit: "إرسال رابط الاستعادة",
    forgotSentTitle: "تم إرسال الطلب",
    forgotSentDesc: "إذا كان هذا البريد مجهّزاً في نظامنا، فستصلك تعليمات استعادة الحساب قريباً.",
    backToLogin: "العودة لتسجيل الدخول",
    resetTitle: "تعيين كلمة مرور جديدة",
    resetDesc: "أدخل كلمة المرور الجديدة وتأكيدها",
    resetSubmit: "تغيير كلمة المرور",
    resetSuccess: "تم تغيير كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول.",
    resetLinkInvalid: "هذا الرابط غير صالح أو منتهي الصلاحية أو تم استخدامه مسبقاً",
    requestNewLink: "اطلب رابطاً جديداً",
    tooManyAttempts: "عدد كبير من المحاولات — يرجى المحاولة بعد ساعة",
    passwordTooShort: "كلمة المرور قصيرة (6 أحرف على الأقل)",
    colDate: "التاريخ",
    acct_6810: "المرافق", acct_6820: "الشحن", acct_6830: "التغليف", acct_6840: "الصيانة", acct_6850: "الضرائب", acct_6890: "مصروفات أخرى",
    importProducts: "استيراد المنتجات",
    importTitle: "استيراد المنتجات من ملف",
    importDesc: "ارفع ملف Excel أو CSV وطابق الأعمدة ثم راجع المعاينة قبل التنفيذ",
    downloadTemplate: "تحميل ملف نموذجي",
    chooseFile: "اختر ملفاً (.xlsx أو .csv)",
    columnMapping: "مطابقة الأعمدة",
    noMap: "— تجاهل —",
    strategyLabel: "طريقة التعامل مع التكرار",
    strategySkip: "إضافة الجديد فقط (تخطي المكرر)",
    strategyUpdate: "تحديث المنتجات الموجودة حسب SKU",
    previewTitle: "معاينة البيانات",
    statusNew: "جديد",
    statusUpdate: "تحديث",
    statusDuplicate: "مكرر",
    statusInvalid: "غير صالح",
    reasonMissingName: "الاسم مفقود",
    reasonInvalidPrice: "سعر غير صالح",
    reasonInvalidQuantity: "كمية غير صالحة",
    reasonDupFile: "مكرر داخل الملف",
    reasonDupDb: "موجود مسبقاً",
    commitImport: "تنفيذ الاستيراد",
    importing: "جارٍ الاستيراد...",
    importDone: "اكتمل الاستيراد",
    importSummaryNew: "منتجات جديدة",
    importSummaryUpdate: "للتحديث",
    importSummaryDuplicate: "مكررة",
    importSummaryInvalid: "صفوف غير صالحة",
    importCreated: "تمت إضافتها",
    importUpdated: "تم تحديثها",
    importSkipped: "تم تخطيها",
    importFailed: "فشل الاستيراد",
    rowLabel: "صف",
    fldName: "اسم المنتج",
    fldSku: "رمز المنتج / SKU",
    fldCategory: "الفئة",
    fldUnit: "وحدة القياس",
    fldPurchasePrice: "سعر الشراء",
    fldSellingPrice: "سعر البيع",
    fldInitialQty: "الكمية الابتدائية",
    fldDescription: "الوصف",
    exportSales: "تصدير المبيعات",
    importSales: "استيراد المبيعات",
    importSalesTitle: "استيراد المبيعات من ملف",
    salesImportDesc: "كل فاتورة تمر عبر مسار البيع اليدوي نفسه — تحديث المخزون وقيود محاسبية متوازنة تلقائياً",
    fldInvoiceRef: "رقم الفاتورة",
    fldDate: "التاريخ",
    fldCustomer: "العميل",
    fldProduct: "المنتج / SKU",
    fldQuantity: "الكمية",
    fldUnitPrice: "سعر البيع",
    fldPaymentMethod: "طريقة الدفع",
    reasonProductNotFound: "المنتج غير موجود",
    reasonInsufficientStock: "المخزون غير كافٍ",
    reasonExistsRef: "مرجع مكرر — مستورد سابقاً",
    invoicesCreated: "فواتير أُنشئت",
    rowsImported: "صفوف مستوردة",
    exportProducts: "تصدير المنتجات",
    selectAll: "تحديد الكل",
    deleteSelected: "حذف المحدد",
    bulkDeleteDone: "اكتمل الحذف الجماعي",
    bulkDeleteSummary: "تم حذف {deleted} منتجاً وأرشفة {archived}",
    archivedNotice: "منتجات لها معاملات سابقة (مبيعات/مشتريات/مرتجعات) تمت أرشفتها بدلاً من حذفها حفاظاً على سلامة القيود المحاسبية وسجل المخزون:",
    qaPurchaseReturn: "مرتجع مشتريات",
    prTitle: "مرتجع مشتريات",
    prDesc: "إرجاع كميات من فاتورة شراء إلى المورد — تُقيَّم بالتكلفة الأصلية المسجلة في فاتورة الشراء",
    prSelectPurchase: "اختر فاتورة الشراء",
    prRefundMethod: "طريقة الاسترداد",
    prReason: "السبب",
    prReturnQty: "كمية الإرجاع",
    prPurchased: "مشتراة",
    prAlreadyReturned: "مُرجَع سابقاً",
    prOriginalCost: "التكلفة الأصلية",
    prSubmit: "تنفيذ المرتجع",
    prSuccess: "تم تسجيل مرتجع المشتريات وعكس قيمة المخزون بقيد متوازن",
    prBtn: "مرتجع",
    colInvoiceNo: "رقم الفاتورة",
    colCustomer: "العميل",
    colTotal: "الإجمالي",
    colCogs: "التكلفة (COGS)",
    colQtySold: "الكمية المباعة",
    colPerUnit: "لكل وحدة",
    colValue: "القيمة",
    colShare: "النسبة %",
    colRevenue: "الإيراد",
    colProfit: "الربح",
    colMargin: "الهامش %",
    colStock: "المخزون",
    colMin: "الحد الأدنى",
    colReason: "السبب",
    revDist: "توزيع الإيرادات",
    drillRefunds: "المرتجعات",
    drillCogsNet: "صافي تكلفة البضاعة",
    drillNetBusiness: "صافي الربح التشغيلي",
    drillEmpty: "لا توجد بيانات تفصيلية",
    colProduct: "المنتج",
    colCost: "تكلفة الوحدة",
    acctGroup_expenses: "المصاريف",
    acct_1000: "الأصول", acct_1100: "النقدية", acct_1200: "البنك", acct_1300: "العملاء (ذمم مدينة)", acct_1400: "المخزون", acct_1500: "الأصول الثابتة", acct_1600: "مصروفات مدفوعة مسبقًا",
    acct_2000: "الالتزامات", acct_2100: "الموردون (ذمم دائنة)", acct_2200: "القروض", acct_2300: "الضرائب المستحقة", acct_2400: "الرواتب المستحقة",
    acct_3000: "حقوق الملكية", acct_3100: "رأس المال", acct_3200: "مسحوبات المالك", acct_3300: "الأرباح المحتجزة",
    acct_4000: "الإيرادات", acct_4100: "مبيعات المنتجات", acct_4200: "إيرادات الخدمات", acct_4300: "إيرادات أخرى",
    acct_5000: "تكلفة المبيعات", acct_5100: "تكلفة البضاعة المباعة", acct_5200: "شحن المشتريات", acct_5300: "تكاليف مباشرة",
    acct_6000: "المصاريف", acct_6100: "الإيجار", acct_6200: "الرواتب", acct_6300: "التسويق", acct_6400: "المواصلات", acct_6500: "الاتصالات", acct_6600: "العمولات", acct_6700: "المصاريف البنكية",
    errAcctCodeExists: "رقم الحساب موجود مسبقًا",
    errAcctSystemDelete: "الحسابات الافتراضية لا يمكن حذفها — يمكن إيقافها فقط",
    errAcctHasChildren: "الحساب يحتوي على حسابات فرعية — يمكن إيقافه فقط",
    errAcctLinked: "الحساب مرتبط بقيود محاسبية — يمكن إيقافه فقط",
    errAcctSystemEdit: "الحسابات الافتراضية يمكن تفعيلها أو إيقافها فقط",
    errAcctParentGroup: "الحساب الأب يجب أن يكون ضمن نفس نوع الحساب",
    errAcctParentInactive: "الحساب الأب غير نشط",
    errAcctDepth: "تم بلوغ الحد الأقصى لمستويات الحسابات",
    errAcctBadSubgroup: "المجموعة الفرعية غير صالحة لنوع الحساب المحدد",
    fShipping: "تكلفة الشحن",
    fAds: "تكلفة الإعلان",
    fFee: "عمولة الدفع والمنصة",
    fDiscount: "الخصم",
    fOther: "تكاليف أخرى",
    fQty: "الكمية المباعة",
    liveTitle: "الحساب المباشر",
    unitCost: "التكلفة الإجمالية للوحدة",
    unitProfit: "ربح الوحدة",
    totalProfitLabel: "الربح الإجمالي",
    saveProduct: "حفظ المنتج",
    saving: "جارٍ الحفظ...",
    productSaved: "تمت إضافة المنتج بنجاح",
    productUpdated: "تم تحديث المنتج بنجاح",
    perUnit: "للوحدة",
    unitsSold: "وحدة مباعة",
    back: "رجوع",
    sellingPrice: "سعر البيع",
    totalCostsLabel: "إجمالي التكاليف",
    revenueLabel: "الإيرادات",
    breakdownTitle: "تفصيل التكاليف (لكل وحدة)",
    simTitle: "محاكي الأسعار",
    simDesc: "جرّب سعرًا جديدًا وشاهد تأثيره فورًا",
    simNewPrice: "السعر الجديد",
    simCurrentPrice: "السعر الحالي",
    simCurrentProfit: "الربح الحالي",
    simNewProfit: "الربح الجديد",
    simNewMargin: "الهامش الجديد",
    simDiff: "الفرق عن الحالي",
    reportsTitle: "التقارير",
    reportsSubtitle: "ملخص أداء منتجاتك",
    reportsComingSoon: "تقارير متقدمة (زمنية وتصدير) قادمة قريبًا.",
    settingsTitle: "الإعدادات",
    account: "الحساب",
    languageLabel: "اللغة",
    languageDesc: "اختر لغة الواجهة — تُحفظ تلقائيًا",
    demoSection: "البيانات التجريبية",
    demoSectionDesc: "8 منتجات عينة بأسعار وتكاليف وهوامش متنوعة لاستكشاف التطبيق",
    backupSection: "النسخ الاحتياطي",
    backupDesc: "حمّل نسخة كاملة من بيانات نشاطك التجاري (المنتجات، المبيعات، المشتريات، المصروفات، الحسابات والقيود المحاسبية) بصيغة JSON للاحتفاظ بها",
    backupDownload: "تحميل نسخة احتياطية",
    obTitle: "إعداد حسابك",
    obWelcomeTitle: "أهلاً بك في ProfitLens 👋",
    obWelcomeSub: "خلينا نجهز حسابك بخطوات بسيطة.",
    obStart: "ابدأ الإعداد",
    obSkipNow: "تخطي الآن",
    obContinueLater: "المتابعة لاحقاً",
    obBack: "رجوع",
    obBizStep: "معلومات نشاطك التجاري",
    obBizStepSub: "حدّث بيانات شركتك الأساسية — يمكنك تعديلها لاحقاً من الإعدادات",
    obBizType: "نوع النشاط التجاري",
    obType_retail: "تجارة تجزئة",
    obType_ecommerce: "تجارة إلكترونية",
    obType_services: "خدمات",
    obType_food: "أغذية ومطاعم",
    obType_wholesale: "تجارة جملة",
    obType_other: "أخرى",
    obSaveContinue: "حفظ ومتابعة",
    obProductsStep: "منتجاتك",
    obProductsStepSub: "أضف منتجاتك لتبدأ بتتبع أرباحك الحقيقية",
    obAddProduct: "إضافة أول منتج",
    obImportProducts: "استيراد من Excel/CSV",
    obOpeningStep: "الأرصدة الافتتاحية",
    obOpeningDesc: "الرصيد الافتتاحي اختياري وهو النقدية المتوفرة لديك عند بدء استخدام النظام. لن يتم إنشاء أي قيود محاسبية تلقائياً — يمكنك تعيينه الآن أو لاحقاً من الإعدادات.",
    obSetOpening: "تعيين الرصيد الافتتاحي",
    obActionStep: "أول عملية تجارية",
    obActionStepSub: "سجّل أول حركة حقيقية وابدأ رحلتك مع ProfitLens",
    obFirstSale: "تسجيل أول بيع",
    obFirstPurchase: "إضافة أول شراء",
    obFirstExpense: "إضافة أول مصروف",
    obCompleteTitle: "ممتاز! 🎉",
    obCompleteSub: "أصبح ProfitLens جاهزاً لمساعدتك في إدارة عملك.",
    obChkBusiness: "إعداد النشاط التجاري",
    obChkProducts: "المنتجات",
    obChkOpening: "الأرصدة الافتتاحية",
    obChkFirstTx: "أول عملية",
    obGoDashboard: "الانتقال إلى لوحة التحكم",
    obResume: "استئناف الإعداد",
    obBannerSub: "أكمل الخطوات المتبقية للحصول على أقصى استفادة من ProfitLens",
    obTour: "جولة تعريفية",
    obSkipped: "تم تخطيه",
    obDoneStatus: "مكتمل",
    obPendingStatus: "غير مكتمل",
    lpHeroTitle: "اعرف ربحك الحقيقي.",
    lpHeroSub: "ProfitLens يساعدك على إدارة المبيعات والمشتريات والمخزون والمصاريف والحسابات، ويمنحك رؤية واضحة لربح نشاطك الحقيقي.",
    lpHeroCta: "ابدأ مجاناً",
    lpHeroCta2: "شاهد كيف يعمل",
    lpHeroTrust: "ابدأ بدون بطاقة بنكية.",
    lpModulesTitle: "كل أعمالك في مكان واحد",
    lpMod_sales: "المبيعات",
    lpMod_sales_d: "سجّل فواتير البيع نقداً أو بالدين وتتبع ربح كل فاتورة لحظياً.",
    lpMod_purchases: "المشتريات",
    lpMod_purchases_d: "أدر فواتير الشراء من الموردين واربطها بالمخزون تلقائياً.",
    lpMod_inventory: "المخزون",
    lpMod_inventory_d: "كميات محدثة لحظياً مع تنبيهات انخفاض المخزون قبل نفادها.",
    lpMod_cash: "الخزينة والحسابات",
    lpMod_cash_d: "تابع النقدية والسحوبات والأرصدة المتوقعة بشكل يومي.",
    lpMod_accounting: "المحاسبة والقوائم المالية",
    lpMod_accounting_d: "قيود يومية تلقائية متوازنة وقوائم مالية جاهزة دائماً.",
    lpMod_reports: "التقارير والتحليلات",
    lpMod_reports_d: "تقارير أرباح ومبيعات ومخزون تكشف لك الصورة كاملة.",
    lpAccTitle: "عملياتك اليومية مربوطة بالمحاسبة تلقائياً",
    lpAccSub: "كل حركة تجارية تنعكس فوراً على دفاترك المحاسبية بدون أي إدخال يدوي.",
    lpAcc1: "المبيعات والمشتريات تولّد قيود يومية متوازنة تلقائياً.",
    lpAcc2: "حركات المخزون وتكلفة البضاعة المباعة مرتبطة بالسجلات المحاسبية الفعلية.",
    lpAcc3: "المصاريف التشغيلية تُحمَّل على الحسابات المالية الصحيحة.",
    lpAcc4: "ميزان المراجعة وقائمة الدخل والميزانية العمومية مشتقة من القيود المرحّلة.",
    lpAiTitle: "🤖 ذكاء مالي يفهم أرقامك كما يفهمها الخبير.",
    lpAiDesc: "حلّل مبيعاتك، أرباحك، مصاريفك، مخزونك وهوامش الربح، واحصل على إجابات وتوصيات واضحة تساعدك على فهم عملك واتخاذ قراراتك بثقة.",
    lpAiTag: "مساعد مالي ذكي معك في كل خطوة.",
    lpAiCap1: "المساعد المالي الذكي",
    lpAiCap2: "رؤى مالية ذكية",
    lpAiCap3: "تحليلات مالية متقدمة",
    lpAiCap4: "المنتجات الأكثر ربحية",
    lpAiCap5: "تحليل المبيعات المرتفعة منخفضة الربح",
    lpAiCap6: "تنبيهات الهوامش المنخفضة والتوصيات",
    lpKpiTitle: "لوحة تحكم تُريك كل شيء",
    lpKpiSub: "راقب مؤشرات نشاطك لحظة بلحظة من مكان واحد — أرقامك الحقيقية، دائماً.",
    lpKpiSales: "المبيعات",
    lpKpiCogs: "تكلفة البضاعة المباعة",
    lpKpiGross: "الربح الإجمالي",
    lpKpiNet: "الربح الصافي",
    lpKpiMargin: "هامش الربح",
    lpKpiInventory: "قيمة المخزون",
    lpKpiCash: "رصيد الخزينة",
    lpKpiProducts: "ربحية المنتجات",
    lpAudTitle: "مصمم لأصحاب الأعمال",
    lpAud1: "محلات التجزئة",
    lpAud2: "الأعمال الصغيرة",
    lpAud3: "الأعمال التجارية",
    lpAud4: "تجارة الجملة",
    lpAud5: "الأعمال الخدمية",
    lpHowTitle: "كيف يعمل ProfitLens؟",
    lpHow1: "أنشئ حسابك",
    lpHow1d: "سجّل مجاناً في أقل من دقيقة — بدون بطاقة بنكية.",
    lpHow2: "أضف منتجاتك وبيانات نشاطك",
    lpHow2d: "أضف منتجاتك يدوياً أو استوردها دفعة واحدة من Excel.",
    lpHow3: "ابدأ البيع والإدارة واعرف ربحك الحقيقي",
    lpHow3d: "كل عملية تنعكس على التقارير والمحاسبة فوراً.",
    lpHowCta: "ابدأ الآن مجاناً",
    lpPriceTitle: "أسعار بسيطة وواضحة",
    lpPriceSub: "ابدأ مجاناً ورقِّ حسابك عندما تحتاج قوة الذكاء الاصطناعي.",
    lpPlanFree: "الخطة المجانية",
    lpPlanFreePrice: "مجاناً",
    lpFree1: "إدارة المنتجات والمبيعات والمشتريات",
    lpFree2: "المخزون والتقارير الأساسية",
    lpFree3: "المحاسبة والقوائم المالية",
    lpFree4: "بدون بطاقة بنكية",
    lpPlanPremium: "Premium",
    lpPlanAnnual: "الخطة السنوية",
    lpAnnualFirstYear: "للسنة الأولى — سعر تأسيسي",
    lpAnnualRenewal: "$299 عند التجديد السنوي",
    lpPrem1: "كل ميزات الخطة المجانية",
    lpPrem2: "المساعد المالي بالذكاء الاصطناعي",
    lpPrem3: "الرؤى والتحليلات الذكية",
    lpPrem4: "تنبيهات الهوامش المنخفضة والتوصيات",
    lpBestValue: "الأكثر توفيراً",
    lpStartFree: "ابدأ مجاناً",
    lpStartPremium: "ابدأ Premium",
    lpSecTitle: "أمان وثقة",
    lpSec1: "مصادقة آمنة لحسابك",
    lpSec2: "صلاحيات دقيقة حسب الدور",
    lpSec3: "سلامة محاسبية بقيود متوازنة",
    lpSec4: "نسخ احتياطي كامل للمالك",
    lpSec5: "مدفوعات آمنة عبر PayPal",
    lpFaqTitle: "الأسئلة الشائعة",
    lpFaq1Q: "هل ProfitLens مجاني؟",
    lpFaq1A: "نعم، الخطة المجانية تشمل إدارة المنتجات والمبيعات والمشتريات والمخزون والمحاسبة والتقارير، ويمكنك الترقية إلى Premium في أي وقت.",
    lpFaq2Q: "هل أحتاج بطاقة بنكية للتجربة؟",
    lpFaq2A: "لا، يمكنك إنشاء حسابك والبدء فوراً بدون أي بطاقة بنكية.",
    lpFaq3Q: "هل يدعم المبيعات والمشتريات والمخزون؟",
    lpFaq3A: "نعم، ProfitLens يدير دورة العمل كاملة من الشراء إلى البيع مع تحديث المخزون لحظياً.",
    lpFaq4Q: "هل المحاسبة مرتبطة بالعمليات؟",
    lpFaq4A: "نعم، كل عملية بيع أو شراء أو مصروف تولّد قيداً محاسبياً متوازناً تلقائياً، والقوائم المالية مشتقة من القيود المرحّلة.",
    lpFaq5Q: "ما الفرق بين Free وPremium؟",
    lpFaq5A: "Premium يضيف المساعد المالي بالذكاء الاصطناعي والرؤى والتحليلات المتقدمة وتنبيهات الهوامش المنخفضة والتوصيات.",
    lpFaq6Q: "هل يوجد مساعد مالي بالذكاء الاصطناعي؟",
    lpFaq6A: "نعم، في خطة Premium تحصل على مساعد مالي ذكي يحلل أرقامك ويجيب على أسئلتك ويقدم توصيات واضحة.",
    lpFaq7Q: "هل يمكنني إلغاء الاشتراك؟",
    lpFaq7A: "نعم، يمكنك إلغاء اشتراكك في أي وقت من صفحة الاشتراك داخل حسابك بدون أي التزامات.",
    lpSupportTitle: "تحتاج مساعدة؟ تواصل معنا",
    lpSupportSub: "فريقنا جاهز للإجابة على أسئلتك ومساعدتك في البدء.",
    lpWhats: "واتساب",
    lpEmail: "البريد الإلكتروني",
    lpFinalTitle: "جاهز تعرف ربحك الحقيقي؟",
    lpFinalSub: "ابدأ بإدارة أعمالك بطريقة أوضح.",
    lpFooterRights: "© ProfitLens — جميع الحقوق محفوظة",
    lpLogin: "تسجيل الدخول",
    pwaOffline: "لا يوجد اتصال بالإنترنت",
    pwaOfflineSub: "تعذر الاتصال بالخادم. ستُستأنف المزامنة عند عودة الاتصال.",
    pwaUpdateTitle: "يتوفر إصدار جديد من ProfitLens",
    pwaUpdateSub: "حدّث الآن للحصول على أحدث التحسينات. لن تفقد بياناتك.",
    pwaUpdateBtn: "تحديث",
    pwaLater: "لاحقاً",
    pwaInstallTitle: "تثبيت ProfitLens",
    pwaInstallSub: "ثبّت التطبيق على جهازك للوصول السريع وتجربة أفضل.",
    pwaInstallBtn: "تثبيت",
    pwaIosTitle: "إضافة إلى الشاشة الرئيسية",
    pwaIosStep1: "اضغط زر المشاركة (Share) في متصفح Safari",
    pwaIosStep2: "مرّر للأسفل واختر «إضافة إلى الشاشة الرئيسية»",
    pwaIosStep3: "اضغط «إضافة» في الأعلى",
    pwaClose: "إغلاق",
    draftSaving: "جارٍ الحفظ…",
    draftSaved: "تم الحفظ تلقائياً",
    draftSaveFailed: "فشل الحفظ — محفوظ محلياً وسيُعاد المحاولة",
    draftRestored: "تم استرجاع آخر مسودة محفوظة",
    lpNavFeatures: "المميزات",
    lpNavPricing: "الأسعار",
    lpNavAbout: "من نحن",
    seoHomeTitle: "ProfitLens | Accounting Software for Retail Stores",
    seoHomeDesc: "Manage sales, purchases, inventory, and expenses in one place with ProfitLens. Track your profits and financial reports easily. Start for free.",
    seoFeaturesTitle: "المميزات | ProfitLens — مبيعات، مخزون، محاسبة، تقارير وذكاء مالي",
    seoFeaturesDesc: "كل أعمالك في مكان واحد: المبيعات والمشتريات والمخزون والخزينة والمحاسبة والقوائم المالية والتقارير والمساعد المالي الذكي.",
    seoPricingTitle: "الأسعار | ProfitLens — خطة مجانية وPremium بـ $29 شهرياً",
    seoPricingDesc: "ابدأ مجاناً بدون بطاقة بنكية. Premium بـ $29 شهرياً أو $99 للسنة الأولى — مساعد مالي ذكي وتحليلات متقدمة وتنبيهات هوامش.",
    seoAboutTitle: "من نحن | ProfitLens — نظام ذكي لإدارة الأعمال",
    seoAboutDesc: "ProfitLens وُلد ليمنح صاحب العمل الصغير رؤية واضحة لربحه الحقيقي — إدارة عمليات ومحاسبة تلقائية وذكاء مالي في مكان واحد.",
    seoAuthTitle: "تسجيل الدخول أو إنشاء حساب | ProfitLens",
    seoAuthDesc: "سجّل الدخول إلى حسابك في ProfitLens أو أنشئ حساباً مجاناً وابدأ بإدارة أعمالك.",
    notFoundTitle: "الصفحة غير موجودة",
    notFoundDesc: "الرابط الذي تحاول الوصول إليه غير موجود أو تم نقله.",
    notFoundHome: "العودة إلى الصفحة الرئيسية",
    aboutHeroTitle: "وُلد ProfitLens من فكرة بسيطة",
    aboutP1: "صاحب العمل الصغير يستحق أن يعرف ربحه الحقيقي — ليس تقديراً أو تخميناً، بل رقماً دقيقاً مشتقاً من كل عملية بيع وشراء ومصروف يسجّلها.",
    aboutP2: "بنينا ProfitLens ليجمع إدارة العمليات اليومية والمحاسبة التلقائية والذكاء المالي في نظام واحد بسيط، باللغة العربية أولاً، وبأسعار في متناول الأعمال الصغيرة.",
    costUnavailable: "التكلفة غير متوفرة",
    dangerZone: "منطقة الخطر",
    deleteAllData: "حذف جميع بيانات الشركة",
    deleteAllDataDesc: "حذف نهائي لجميع المبيعات والمشتريات والمنتجات والمخزون والمصروفات والخزينة والشركاء والقيود المحاسبية وكل البيانات التشغيلية. يبقى حسابك واشتراكك وإعداداتك كما هي.",
    dangerBackupHint: "نوصي بتحميل نسخة احتياطية أولاً من قسم النسخ الاحتياطي أعلاه.",
    dangerModalTitle: "تحذير: حذف نهائي لجميع البيانات",
    dangerModalDesc: "سيتم حذف جميع بيانات الشركة التشغيلية والمحاسبية نهائياً ولا يمكن التراجع عن هذا الإجراء.",
    dangerPhraseLabel: "للتأكيد، اكتب العبارة التالية حرفياً:",
    dangerContinue: "متابعة",
    dangerFinalTitle: "تأكيد أخير",
    dangerFinalDesc: "هذه هي الخطوة الأخيرة. هل أنت متأكد تماماً من حذف جميع بيانات الشركة؟",
    dangerConfirm: "نعم، احذف كل شيء نهائياً",
    dataDeleted: "تم حذف جميع بيانات الشركة — يمكنك البدء من جديد",
    deleting: "جارٍ الحذف...",
    demoLoaded: "تم تحميل البيانات التجريبية",
    demoCleared: "تم حذف البيانات التجريبية",
    requiredBadge: "إلزامي",
    optionalBadge: "اختياري",
    requiredSection: "الأساسيات",
    optionalSection: "التكاليف الاختيارية",
    optionalSectionDesc: "اترك أي حقل فارغًا وسيُحتسب صفرًا — اختر طريقة الإدخال لكل تكلفة",
    launchDate: "تاريخ بدء البيع",
    launchDateHint: "اختياري — متى بدأت بيع هذا المنتج؟",
    createdAtLabel: "تاريخ الإضافة",
    lastUpdated: "آخر تحديث",
    notSpecified: "غير محدد",
    productAge: "عمر المنتج",
    ageToday: "اليوم",
    modeUnit: "لكل وحدة",
    modeTotal: "إجمالي الفترة",
    modeFixed: "مبلغ ثابت",
    modePercent: "نسبة مئوية",
    hintUnit: "مثال: $2 لكل منتج",
    hintTotal: "مثال: $100 إجمالي للفترة",
    hintFixed: "مثال: $1 خصم لكل منتج",
    hintPercent: "مثال: 10% من سعر البيع",
    totalModeNote: "{total} إجمالي ÷ {qty} وحدة",
    percentNote: "{pct}% من سعر البيع",
    discountTooHigh: "نسبة الخصم يجب أن تكون بين 0 و 100",
    navSales: "المبيعات",
    navPurchases: "المشتريات",
    navInventory: "المخزون",
    navReturns: "المرتجعات",
    navExpenses: "المصروفات",
    navCash: "الخزينة",
    navEmployees: "الموظفون",
    navPartners: "الشركاء",
    navAudit: "سجل العمليات",
    quickActions: "إجراءات سريعة",
    qaAddProduct: "إضافة منتج",
    qaNewSale: "تسجيل بيع",
    qaNewPurchase: "إضافة شراء",
    qaNewReturn: "تسجيل مرتجع",
    qaAddExpense: "إضافة مصروف",
    setupTitle: "أكمل إعداد نشاطك التجاري",
    setupDesc: "اسم النشاط والعملة الأساسية — يمكنك تغييرها لاحقًا من الإعدادات",
    bizName: "اسم النشاط التجاري",
    bizNamePh: "مثال: متجر النور",
    bizCurrency: "العملة الأساسية",
    bizTimezone: "المنطقة الزمنية",
    setupSave: "بدء العمل",
    bizSaved: "تم حفظ إعدادات النشاط",
    bizSave: "حفظ الإعدادات",
    roleLabel: "الدور",
    roleOwner: "مالك",
    roleManager: "مدير",
    roleEmployee: "موظف",
    roleAccountant: "محاسب",
    salesTitle: "المبيعات",
    newSale: "تسجيل بيع",
    saleNumber: "رقم البيع",
    customer: "العميل (اختياري)",
    customerPh: "اسم العميل",
    paymentMethod: "طريقة الدفع",
    pmCash: "نقدي",
    pmCard: "بطاقة",
    pmTransfer: "تحويل",
    pmOther: "أخرى",
    pmCredit: "آجل",
    itemsLabel: "الأصناف",
    addItem: "إضافة صنف",
    selectProduct: "اختر المنتج",
    qtyLabel: "الكمية",
    unitPriceLabel: "سعر الوحدة",
    unitType: "وحدة القياس",
    unitGram: "غرام",
    unitKilogram: "كيلوغرام",
    unitMilliliter: "ملليلتر",
    unitPiece: "قطعة",
    unitLiter: "لتر",
    unitMeter: "متر",
    unitCentimeter: "سنتيمتر",
    unitBox: "علبة",
    unitSet: "طقم",
    unitOther: "أخرى",
    currencyLabel: "العملة",
    curSYP: "ليرة سورية",
    curUSD: "دولار أمريكي",
    curEGP: "جنيه مصري",
    curEUR: "يورو",
    curAED: "درهم إماراتي",
    lineDiscount: "خصم",
    lineTotal: "الإجمالي",
    subtotalLabel: "المجموع الفرعي",
    grandTotal: "الإجمالي النهائي",
    confirmSale: "تأكيد البيع",
    editSaleTitle: "تعديل فاتورة بيع",
    editPurchaseTitle: "تعديل فاتورة شراء",
    editReturnTitle: "تعديل المرتجع",
    saveChanges: "حفظ التعديلات",
    saleUpdated: "تم تحديث فاتورة البيع",
    purchaseUpdated: "تم تحديث فاتورة الشراء",
    returnUpdated: "تم تحديث المرتجع",
    editPinTitle: "تعديل فاتورة محمي",
    editPinDesc: "أدخل رمز PIN للمالك لفتح صفحة التعديل",
    editPasswordDesc: "أدخل كلمة مرور حسابك لفتح صفحة التعديل",
    wrongPasswordMsg: "كلمة المرور غير صحيحة",
    editNoAuthSetup: "التعديل محمي — يجب إعداد رمز PIN أو كلمة مرور للحساب أولاً",
    goToSettings: "الانتقال إلى الإعدادات",
    countryLabel: "الدولة",
    detectedCountryHint: "تم اكتشاف دولتك تلقائيًا: {country} — يمكنك تغييرها في أي وقت",
    dateFormatLabel: "تنسيق التاريخ",
    numberFormatLabel: "تنسيق الأرقام",
    currencyChangeNote: "تغيير الدولة أو العملة لا يحوّل أو يعدّل أي مبالغ أو فواتير مسجلة سابقًا — يؤثر على العرض والعملة الافتراضية فقط",
    saleCreated: "تم تسجيل البيع بنجاح",
    saleCancelledMsg: "تم إلغاء البيع",
    cancelSaleBtn: "إلغاء البيع",
    statusConfirmed: "مؤكد",
    statusCancelled: "ملغي",
    dateLabel: "التاريخ",
    soldBy: "البائع",
    cogsLabel: "تكلفة البضاعة المباعة",
    grossProfitLabel: "مجمل الربح",
    profitLabel: "الربح",
    noSales: "لا توجد مبيعات بعد",
    purchasesTitle: "المشتريات",
    newPurchase: "إضافة شراء",
    purchaseNumber: "رقم الشراء",
    supplier: "المورد",
    supplierPh: "اسم المورد",
    invoiceNumber: "رقم الفاتورة",
    purchaseDate: "تاريخ الشراء",
    unitCostLabel: "تكلفة الوحدة",
    additionalCostsLabel: "تكاليف إضافية",
    confirmPurchase: "تأكيد الشراء",
    purchaseCreated: "تم تسجيل الشراء بنجاح",
    noPurchases: "لا توجد مشتريات بعد",
    returnsTitle: "المرتجعات",
    newReturn: "تسجيل مرتجع",
    returnNumber: "رقم المرتجع",
    originalSale: "البيع الأصلي (اختياري)",
    reasonLabel: "السبب",
    rChangedMind: "العميل غيّر رأيه",
    rDamaged: "تالف",
    rWrongProduct: "منتج خاطئ",
    rDefect: "عيب في المنتج",
    rOther: "أخرى",
    restockLabel: "إعادة الكمية إلى المخزون",
    refundTotalLabel: "قيمة المرتجع",
    refundMethod: "طريقة الاسترداد",
    confirmReturn: "تأكيد المرتجع",
    returnCreated: "تم تسجيل المرتجع بنجاح",
    noReturns: "لا توجد مرتجعات بعد",
    expensesTitle: "المصروفات",
    newExpense: "إضافة مصروف",
    amountLabel: "المبلغ",
    categoryLabel: "الفئة",
    descriptionLabel: "الوصف",
    notesLabel: "ملاحظات",
    cat_rent: "إيجار",
    cat_utilities: "خدمات ومرافق",
    cat_salaries: "رواتب",
    cat_advertising: "إعلانات",
    cat_shipping: "شحن",
    cat_packaging: "تغليف",
    cat_maintenance: "صيانة",
    cat_transportation: "مواصلات",
    cat_taxes: "ضرائب",
    cat_other: "أخرى",
    expenseCreated: "تمت إضافة المصروف",
    expenseUpdated: "تم تحديث المصروف",
    expenseDeleted: "تم حذف المصروف",
    noExpenses: "لا توجد مصروفات بعد",
    editExpense: "تعديل المصروف",
    inventoryTitle: "المخزون",
    currentStock: "المخزون الحالي",
    minStockLabel: "الحد الأدنى",
    stockStatus: "الحالة",
    stOk: "جيد",
    stLow: "منخفض",
    stOut: "نفد",
    lowStockTitle: "منتجات منخفضة المخزون",
    recentMovements: "آخر الحركات",
    movementType: "النوع",
    mv_PURCHASE: "شراء",
    mv_SALE: "بيع",
    mv_RETURN: "مرتجع",
    mv_ADJUSTMENT: "تسوية",
    mv_DAMAGE: "تالف",
    mv_MANUAL_CORRECTION: "تصحيح يدوي",
    adjustStock: "تسوية المخزون",
    adjustQty: "الكمية (+ للإضافة / − للخصم)",
    referenceLabel: "المرجع",
    byLabel: "بواسطة",
    inventoryValue: "قيمة المخزون",
    movementAdded: "تمت إضافة حركة المخزون",
    qtyChange: "التغيير",
    cashTitle: "الخزينة",
    openingBalance: "الرصيد الافتتاحي",
    cashSalesLabel: "مبيعات نقدية",
    cashRefundsLabel: "مرتجعات نقدية",
    cashExpensesLabel: "مصروفات نقدية",
    cashWithdrawalsLabel: "مسحوبات نقدية",
    cashBalance: "الرصيد الحالي",
    expectedCash: "النقد المتوقع",
    actualCash: "النقد الفعلي",
    differenceLabel: "الفرق",
    dailyClosing: "إقفال اليوم",
    closingSaved: "تم تسجيل الإقفال",
    closingsHistory: "سجل الإقفالات",
    withdrawalsTitle: "المسحوبات",
    newWithdrawal: "تسجيل مسحوبة",
    personLabel: "الشخص",
    personPh: "اسم الشخص",
    sourceLabel: "المصدر",
    srcCash: "الخزينة",
    srcBank: "البنك",
    withdrawalCreated: "تم تسجيل المسحوبة",
    noWithdrawals: "لا توجد مسحوبات",
    noClosings: "لا توجد إقفالات بعد",
    employeesTitle: "الموظفون",
    addEmployee: "إضافة موظف",
    phoneLabel: "الهاتف",
    salaryLabel: "الراتب",
    commissionLabel: "العمولة",
    hireDateLabel: "تاريخ التعيين",
    statusLabel: "الحالة",
    statusActive: "نشط",
    statusInactive: "غير نشط",
    permissionsTitle: "الصلاحيات",
    editPermissions: "تعديل الصلاحيات",
    employeeCreated: "تمت إضافة الموظف",
    employeeUpdated: "تم تحديث بيانات الموظف",
    permissionsUpdated: "تم تحديث الصلاحيات",
    passwordLabel: "كلمة المرور",
    editEmployee: "تعديل الموظف",
    partnersTitle: "الشركاء",
    addPartner: "إضافة شريك",
    ownershipLabel: "نسبة الملكية %",
    partnerCreated: "تمت إضافة الشريك",
    txnType: "نوع المعاملة",
    ttAllocation: "توزيع أرباح",
    ttWithdrawal: "سحب",
    ttContribution: "مساهمة / إيداع",
    balanceLabel: "الرصيد",
    addTransaction: "إضافة معاملة",
    txnCreated: "تمت إضافة المعاملة",
    transactionsLabel: "المعاملات",
    noPartners: "لا يوجد شركاء بعد",
    noTxns: "لا توجد معاملات",
    repSales: "تقرير المبيعات",
    repPurchases: "تقرير المشتريات",
    repInventory: "تقرير المخزون",
    repReturns: "تقرير المرتجعات",
    repExpenses: "تقرير المصروفات",
    repProfit: "تقرير الأرباح",
    repCash: "تقرير الخزينة",
    reportType: "نوع التقرير",
    rangeToday: "اليوم",
    range7: "آخر 7 أيام",
    range30: "آخر 30 يوم",
    rangeMonth: "هذا الشهر",
    rangeLastMonth: "الشهر الماضي",
    rangeYear: "هذه السنة",
    rangeCustom: "تاريخ مخصص",
    fromLabel: "من تاريخ",
    toLabel: "إلى تاريخ",
    viewReport: "عرض التقرير",
    selectBothDates: "اختر تاريخ البداية والنهاية",
    netRevenue: "صافي الإيرادات",
    opExpenses: "مصروفات التشغيل",
    refundsLabel: "المرتجعات",
    grossMarginLabel: "هامش مجمل الربح",
    netMarginLabel: "هامش صافي الربح",
    auditTitle: "سجل العمليات",
    actionLabel: "الإجراء",
    entityLabel: "العنصر",
    summaryLabel: "التفاصيل",
    timeLabel: "الوقت",
    noAudit: "لا توجد سجلات بعد",
    statInventoryValue: "قيمة المخزون",
    statCash: "رصيد الخزينة",
    statLowStock: "مخزون منخفض",
    statReturns: "المرتجعات",
    statExpenses: "المصروفات التشغيلية",
    statCogs: "تكلفة المبيعات",
    statGrossProfit: "مجمل الربح",
    businessSection: "النشاط التجاري",
    allowNegStock: "السماح بالمخزون السالب",
    viewAudit: "عرض سجل العمليات",
    noPermission: "لا تملك صلاحية الوصول إلى هذه الصفحة",
    stockCol: "المخزون",
    minStockField: "الحد الأدنى للمخزون",
    minStockHint: "تنبيه عند انخفاض المخزون إلى هذا الحد",
    perm_products_view: "عرض المنتجات",
    perm_products_manage: "إدارة المنتجات",
    perm_finance_view: "عرض التكاليف والأرباح",
    perm_inventory_view: "عرض المخزون",
    perm_inventory_adjust: "تسوية المخزون",
    perm_purchases_view: "عرض المشتريات",
    perm_purchases_manage: "إدارة المشتريات",
    perm_sales_view: "عرض المبيعات",
    perm_sales_create: "تسجيل المبيعات",
    perm_sales_cancel: "إلغاء المبيعات",
    perm_returns_view: "عرض المرتجعات",
    perm_returns_manage: "إدارة المرتجعات",
    perm_expenses_view: "عرض المصروفات",
    perm_expenses_manage: "إدارة المصروفات",
    perm_cash_view: "عرض الخزينة",
    perm_cash_close: "إقفال الخزينة",
    perm_withdrawals_view: "عرض المسحوبات",
    perm_withdrawals_manage: "تسجيل المسحوبات",
    perm_employees_view: "عرض الموظفين",
    perm_employees_manage: "إدارة الموظفين",
    perm_partners_view: "عرض الشركاء",
    perm_partners_manage: "إدارة الشركاء",
    perm_reports_view: "عرض التقارير",
    perm_reports_financial: "التقارير المالية",
    perm_audit_view: "سجل العمليات",
    perm_settings_manage: "إعدادات النشاط",
    greeting: "مرحباً {name} 👋",
    lockTitle: "تم قفل الجلسة",
    lockDesc: "أدخل كلمة المرور أو رمز PIN للمتابعة",
    unlockBtn: "فتح الجلسة",
    unlockFailed: "بيانات غير صحيحة",
    unlockWithPassword: "الفتح بكلمة المرور",
    unlockWithPin: "الفتح برمز PIN",
    pinSection: "رمز المالك PIN",
    pinDesc: "رمز رقمي (4-8 أرقام) لحماية الأقسام الحساسة مثل الأرباح والشركاء والخزينة",
    pinEnter: "أدخل رمز PIN",
    pinSaved: "تم حفظ رمز PIN",
    pinClearedMsg: "تم إزالة رمز PIN",
    pinClear: "إزالة PIN",
    pinWrong: "رمز PIN غير صحيح",
    pinRequiredTitle: "قسم محمي برمز PIN",
    pinRequiredDesc: "أدخل رمز PIN للمتابعة",
    pinUnlock: "فتح بالرمز",
    pinEnabledLabel: "مفعّل",
    pinDisabledLabel: "غير مفعّل",
    lockTimeout: "القفل التلقائي بعد الخمول",
    lockOff: "معطّل",
    lockMinutes: "{n} دقيقة",
    usersPermsLink: "المستخدمون والصلاحيات",
    cancelPurchase: "إلغاء الشراء",
    purchaseCancelled: "تم إلغاء الشراء",
    cancelReturn: "إلغاء المرتجع",
    returnCancelled: "تم إلغاء المرتجع",
    statusToggle: "تفعيل / تعطيل",
    employeeStatusUpdated: "تم تحديث حالة الموظف",
    perm_products_view: "عرض المنتجات",
    perm_products_create: "إنشاء منتجات",
    perm_products_edit: "تعديل المنتجات",
    perm_products_delete: "حذف المنتجات",
    perm_products_costs: "عرض تكاليف المنتجات",
    perm_sales_view: "عرض المبيعات",
    perm_sales_create: "تسجيل المبيعات",
    perm_sales_edit: "تعديل المبيعات",
    perm_sales_cancel: "إلغاء المبيعات",
    perm_purchases_view: "عرض المشتريات",
    perm_purchases_create: "إنشاء المشتريات",
    perm_purchases_edit: "تعديل المشتريات",
    perm_purchases_cancel: "إلغاء المشتريات",
    perm_inventory_view: "عرض المخزون",
    perm_inventory_adjust: "تسوية المخزون",
    perm_returns_view: "عرض المرتجعات",
    perm_returns_create: "تسجيل المرتجعات",
    perm_returns_edit: "تعديل المرتجعات",
    perm_returns_cancel: "إلغاء المرتجعات",
    perm_expenses_view: "عرض المصروفات",
    perm_expenses_create: "إضافة المصروفات",
    perm_expenses_edit: "تعديل المصروفات",
    perm_expenses_delete: "حذف المصروفات",
    perm_finance_profit: "عرض الأرباح",
    perm_finance_margin: "عرض هامش الربح",
    perm_finance_reports: "التقارير المالية",
    perm_cash_view: "عرض الخزينة",
    perm_cash_close: "إقفال الخزينة",
    perm_salaries_view: "عرض الرواتب",
    perm_withdrawals_view: "عرض المسحوبات",
    perm_withdrawals_manage: "تسجيل المسحوبات",
    perm_employees_view: "عرض الموظفين",
    perm_employees_manage: "إدارة الموظفين",
    perm_partners_view: "عرض الشركاء",
    perm_partners_manage: "إدارة الشركاء",
    perm_users_manage: "إدارة المستخدمين",
    perm_permissions_manage: "إدارة الصلاحيات",
    perm_settings_business: "إعدادات النشاط",
    perm_audit_view: "سجل العمليات",
    kioskTitle: "من يستخدم النظام؟",
    kioskSelect: "اختر اسمك للمتابعة",
    kioskPasswordFor: "أدخل كلمة المرور",
    kioskContinue: "متابعة",
    kioskWrong: "كلمة المرور أو الرمز غير صحيح",
    switchUser: "تبديل المستخدم",
    usernameLabel: "اسم المستخدم / الرمز",
    usernameHint: "اختياري — يُستخدم لتسجيل الدخول بدون بريد إلكتروني. يُنشأ تلقائيًا إذا تُرك فارغًا",
    kioskLoginLink: "دخول برمز الموظف",
    emailLoginLink: "دخول بالبريد الإلكتروني",
    kioskLoginTitle: "دخول الموظفين",
    kioskLoginSubtitle: "أدخل رمز المستخدم وكلمة المرور",
    setupPasswordTitle: "إعداد كلمة المرور لأول مرة",
    setupPasswordDesc: "لم يتم تعيين كلمة مرور لـ {name} بعد. أنشئ كلمة مرور جديدة للمتابعة.",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور",
    passwordMismatch: "كلمتا المرور غير متطابقتين",
    passwordSetSuccess: "تم تعيين كلمة المرور بنجاح",
    setupPasswordLink: "إنشاء كلمة مرور جديدة",
    setupOwnerPin: "رمز PIN الخاص بالمالك",
    passwordOptionalHint: "اختياري — إذا تُرك فارغًا، ينشئ الموظف كلمة المرور بنفسه عند أول تسجيل دخول",
    ownerSetupTitle: "إعداد حساب المالك",
    ownerSetupSubtitle: "اختر اسم المستخدم وكلمة المرور لحسابك الرئيسي",
    emailOrUsername: "البريد الإلكتروني أو اسم المستخدم",
    setupSaveBtn: "حفظ وبدء الاستخدام",
    aiAssistant: "المساعد المالي الذكي",
    aiSubtitle: "اسأل عن مبيعاتك وأرباحك ومخزونك — إجابات من بياناتك الحقيقية",
    aiPlaceholder: "اكتب سؤالك المالي هنا...",
    aiNewChat: "محادثة جديدة",
    aiThinking: "يكتب...",
    aiError: "تعذّر الاتصال بالمساعد، حاول مرة أخرى",
    aiEmpty: "ابدأ بسؤال أو اختر أحد الإجراءات السريعة أدناه",
    qaDaily: "ملخص اليوم",
    qaSales: "تقرير المبيعات",
    qaProfit: "تقرير الأرباح",
    qaExpenses: "تقرير المصروفات",
    qaInventory: "تقرير المخزون",
    qaFull: "التقرير المالي الشامل",
    qaDailyPrompt: "اعطني ملخص اليوم: المبيعات والمصروفات وصافي الربح اليوم مع مقارنة سريعة بآخر ٧ أيام",
    qaSalesPrompt: "اعطني تقرير المبيعات لآخر ٣٠ يومًا: الإيرادات وعدد العمليات وأفضل المنتجات في جدول",
    qaProfitPrompt: "اعطني تقرير الأرباح لآخر ٣٠ يومًا: الإيرادات وتكلفة البضاعة وصافي الربح وهامش الربح لكل عملة",
    qaExpensesPrompt: "اعطني تقرير المصروفات لآخر ٣٠ يومًا: الإجمالي والتوزيع حسب الفئة في جدول",
    qaInventoryPrompt: "اعطني تقرير المخزون: حالة المنتجات والأصناف منخفضة المخزون التي تحتاج إعادة طلب",
    qaFullPrompt: "اعطني تقريرًا ماليًا شاملًا: مبيعات ومشتريات ومصروفات وأرباح آخر ٣٠ يومًا مع تنبيهات المخزون ومقارنة شهرية",
    navSubscription: "الاشتراك",
    subTitle: "إدارة الاشتراك",
    subSubtitle: "اشتراك المساعد المالي الذكي الخاص بشركتك",
    subStatus: "حالة الاشتراك",
    subTrial: "تجربة مجانية",
    subActive: "اشتراك نشط",
    subExpired: "منتهي",
    subTrialEnds: "تاريخ انتهاء التجربة",
    subDaysRemaining: "الأيام المتبقية",
    subActiveSince: "نشط منذ",
    subPlanTitle: "باقة المساعد المالي الذكي",
    subFeature1: "إجابات فورية عن مبيعاتك وأرباحك ومخزونك من بياناتك الحقيقية",
    subFeature2: "تقارير يومية وشهرية ومقارنات بين الفترات",
    subFeature3: "تنبيهات المخزون المنخفض وتحليل ربحية المنتجات",
    subFeature4: "استعلام مباشر عن أي فاتورة أو عميل أو مورد",
    subUpgrade: "ترقية الاشتراك",
    subUpgradeNote: "الدفع الآمن عبر PayPal — لا تُفعَّل الميزات إلا بعد تأكيد الدفع",
    subActivated: "تم تفعيل الاشتراك بنجاح",
    subState_free: "مجاني",
    subState_trial: "تجريبي",
    subState_active: "نشط",
    subState_pending_payment: "قيد المعالجة",
    subState_past_due: "دفع متأخر",
    subState_cancellation_scheduled: "الإلغاء مجدول",
    subState_expired: "منتهي",
    subPlan: "الخطة",
    subCurrentPeriod: "فترة الفوترة الحالية",
    subNextRenewal: "التجديد التالي",
    subEndsOn: "ينتهي في",
    subPaymentStatus: "حالة الدفع",
    subCancelBtn: "إلغاء الاشتراك",
    subCancelTitle: "إلغاء الاشتراك",
    subCancelConfirm: "ستبقى الميزات المميزة فعالة حتى نهاية دورة الفوترة المدفوعة في {date}، ثم يتم التحويل إلى الخطة المجانية. لن يتم حذف أو تعديل أي بيانات أو فواتير أو سجلات مالية.",
    subCancelKeep: "الاحتفاظ بالاشتراك",
    subCancelConfirmBtn: "تأكيد الإلغاء",
    subCancelScheduled: "تمت جدولة الإلغاء — يبقى الوصول حتى نهاية الدورة المدفوعة",
    subCancelledNote: "الإلغاء مجدول — الوصول مستمر حتى {date}",
    subReactivate: "استئناف الاشتراك",
    subReactivated: "تم استئناف اشتراكك",
    subPendingTitle: "جارٍ معالجة الدفع…",
    subPendingDesc: "نتحقق من الدفع مع PayPal — قد يستغرق دقيقة واحدة",
    subRefresh: "تحديث الحالة",
    subPastDueDesc: "فشل آخر دفع للتجديد — الوصول مستمر مؤقتًا حتى نهاية الدورة، حدّث وسيلة الدفع في PayPal",
    subHistoryTitle: "سجل المدفوعات",
    subHistoryEmpty: "لا توجد مدفوعات بعد",
    yearlyComingSoon: "قريبًا",
    subPaypalUnavailable: "بوابة الدفع غير مُعدّة بعد — تواصل مع الدعم",
    subState_unverified: "غير موثّق",
    subUnverifiedDesc: "هذا الاشتراك غير مرتبط باشتراك PayPal موثق. يرجى الاشتراك مرة أخرى عبر PayPal.",
    subNotLinkedMsg: "هذا الاشتراك غير مرتبط باشتراك PayPal موثّق. يرجى الاشتراك مرة أخرى لتفعيل الفوترة عبر PayPal.",
    subCurrentPlan: "الخطة الحالية",
    subPlansTitle: "الباقات",
    subSwitchNote: "يرجى إلغاء الخطة الحالية أولاً قبل الاشتراك بخطة أخرى.",
    subStartDate: "تاريخ البدء",
    subBillingInterval: "دورة الفوترة",
    subIntervalMonth: "شهرية",
    subIntervalYear: "سنوية",
    subAutoRenew: "التجديد التلقائي",
    subAutoOn: "مفعّل",
    subAutoOff: "متوقف",
    subPaypalId: "معرّف اشتراك PayPal",
    heroBadge: "ارتقِ بأعمالك إلى مستوى أعلى 🚀",
    heroTitle: "اختر الباقة المناسبة لك",
    heroSubtitle: "احصل على جميع الأدوات التي تحتاجها لإدارة أعمالك ومتابعة أرباحك الحقيقية",
    monthlyDesc: "مرونة كاملة، بدون التزام طويل",
    annualFirstYear: "للسنة الأولى ثم $299 سنوياً عند التجديد",
    bestSaver: "الأكثر توفيراً",
    saveUpTo: "وفر حتى 67%",
    compareTitle: "مقارنة الباقات",
    colFeature: "الميزة",
    compAI: "المساعد المالي الذكي",
    compInsights: "التوصيات الذكية والتنبيهات",
    compProfit: "تحليلات الأرباح المتقدمة",
    compReports: "تقارير الأرباح التفصيلية",
    compPrice: "السعر",
    compSavings: "التوفير السنوي",
    compMonthlyPrice: "$29 شهريًا",
    compAnnualPrice: "$99 للسنة الأولى",
    compSaveNone: "—",
    compSave67: "حتى 67%",
    trustSecure: "دفع آمن عبر PayPal",
    trustCancel: "إلغاء في أي وقت",
    trustSupport: "دعم مميز",
    trustSetup: "إعداد سريع",
    helpTitle: "محتاج مساعدة في اختيار الباقة؟",
    helpDesc: "فريقنا جاهز لمساعدتك في اختيار الباقة الأنسب لحجم أعمالك",
    helpCta: "تواصل معنا",
    whatsappSupport: "واتساب",
    emailSupport: "البريد الإلكتروني",
    helpToast: "خيار التواصل المباشر سيُتاح قريبًا — كل تفاصيل الباقات موضحة في جدول المقارنة أعلاه",
    colAmount: "المبلغ",
    colStatus: "الحالة",
    pay_completed: "مكتمل",
    pay_pending: "قيد المعالجة",
    pay_cancel_scheduled: "إلغاء مجدول",
    pay_reactivated: "مستأنف",
    subBadgeActive: "اشتراك نشط",
    subPillActive: "مميز · اشتراك نشط",
    subPillTrial: "مميز · تجربة مجانية · متبقٍ {days} يوم",
    subBadgeTrial: "تجربة مجانية — متبقٍ {days} يوم",
    subBadgeExpired: "انتهت التجربة",
    aiLockedTitle: "انتهت الفترة التجريبية للمساعد المالي",
    aiLockedDesc: "باقي أقسام ProfitLens تعمل كالمعتاد. فعّل الاشتراك لمواصلة استخدام المساعد المالي الذكي.",
    aiContactOwner: "تواصل مع مالك الحساب لتفعيل الاشتراك",
    premiumBadge: "مميز",
    premiumLockedTitle: "ميزة مميزة (Premium)",
    premiumLockedDesc: "التحليلات الذكية والتوصيات المالية وتقارير الأرباح المتقدمة متاحة مع اشتراك Premium. باقي أقسام ProfitLens تعمل كالمعتاد.",
    premiumAnalyticsTitle: "التحليلات المالية الذكية — ميزة Premium",
    upgradeNow: "الترقية إلى Premium",
    choosePlan: "اختر باقتك",
    planMonthly: "الباقة الشهرية",
    planYearly: "الباقة السنوية",
    perMonth: "شهريًا",
    perYear: "سنويًا",
    bestValue: "الأوفر — وفّر 72%",
    launchOfferNote: "عرض الإطلاق: $99 للسنة الأولى فقط، ثم $299 سنويًا",
    renewalNote: "سعر التجديد بعد السنة الأولى: ${price} سنويًا",
    freeFeaturesTitle: "مجاني دائمًا",
    premiumFeaturesTitle: "مميزات Premium",
    freeF1: "المبيعات والمشتريات",
    freeF2: "إدارة المخزون",
    freeF3: "المصروفات والعملاء والموردون",
    freeF4: "التقارير الأساسية",
    premF1: "المساعد المالي الذكي",
    premF2: "تحليل المنتجات الأكثر ربحية",
    premF3: "تحليل أدنى هوامش الربح",
    premF4: "تحليل المبيعات مرتفعة ومنخفضة الربح",
    premF5: "التوصيات الذكية والتنبيهات المالية",
    premF6: "توصيات التسعير والهوامش",
    subActivePlan: "اشتراكك نشط — {plan}",
    loading: "جارٍ التحميل...",
    member: "عضو ProfitLens",
    productsCount: "منتج",
  },
  en: {
    appName: "ProfitLens",
    tagline: "Know your real profit",
    navDashboard: "Dashboard",
    navProducts: "Products",
    navAddProduct: "Add Product",
    navReports: "Reports",
    navSettings: "Settings",
    logout: "Log out",
    login: "Log in",
    register: "Sign up",
    name: "Name",
    namePh: "e.g. Jane Smith",
    email: "Email",
    emailPh: "you@example.com",
    password: "Password",
    passwordPh: "At least 6 characters",
    loginTitle: "Welcome back",
    loginSubtitle: "Log in to keep tracking your product profits",
    registerTitle: "Create your free account",
    registerSubtitle: "Start knowing your real profit in minutes",
    noAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    orDivider: "or continue with",
    googleBtn: "Continue with Google",
    somethingWrong: "Something went wrong. Please try again.",
    sessionExpired: "Session expired. Please sign in again.",
    welcome: "Welcome",
    dashboardTitle: "Dashboard",
    dashboardSubtitle: "A clear view of your profit performance",
    totalSales: "Total Sales",
    productCosts: "Product Costs",
    additionalCosts: "Additional Costs",
    netProfit: "Net Profit",
    profitMargin: "Profit Margin",
    profitByProduct: "Net Profit by Product",
    costSplit: "Revenue Split",
    legendNetProfit: "Net Profit",
    legendProductCosts: "Product Costs",
    legendAdditionalCosts: "Additional Costs",
    topProfitable: "Most Profitable",
    lowestMargin: "Lowest Margin",
    volumeLowMargin: "High Sales · Weak Profit",
    insightsTitle: "Smart Insights",
    noInsights: "No alerts right now. Your products look healthy.",
    insightNegative: "You are losing money on {name}. Review costs or price now.",
    insightLow: "{name} has a very low profit margin (below 10%).",
    insightStrong: "{name} is one of your strongest products (margin above 40%).",
    insightVolume: "{name} sells well but generates weak profit.",
    demoActive: "Demo data is active",
    demoActiveDesc: "These are sample products to explore ProfitLens. You can remove them anytime.",
    clearDemo: "Remove demo data",
    loadDemo: "Load demo data",
    emptyTitle: "No products yet",
    emptyDesc: "Add your first product or load demo data to see how ProfitLens works.",
    addFirst: "Add your first product",
    productsTitle: "Products",
    productsSubtitle: "Manage your products and track each one's profitability",
    searchPlaceholder: "Search by name or SKU...",
    filterAll: "All products",
    filterProfitable: "Profitable",
    filterLowMargin: "Low margin (<10%)",
    filterLosing: "Losing money",
    sortProfitHigh: "Profit: high to low",
    sortProfitLow: "Profit: low to high",
    sortMarginHigh: "Margin: high to low",
    sortQtyHigh: "Quantity: high to low",
    sortName: "Name A-Z",
    thProduct: "Product",
    thPrice: "Price",
    thUnitCost: "Unit Cost",
    thQty: "Sold",
    thNetProfit: "Net Profit",
    thMargin: "Margin",
    edit: "Edit",
    delete: "Delete",
    deleteTitle: "Delete product?",
    deleteDesc: "This product will be permanently deleted. This cannot be undone.",
    cancel: "Cancel",
    confirmDelete: "Yes, delete",
    noResults: "No matching results",
    demoBadge: "Demo",
    productDeleted: "Product deleted",
    addProductTitle: "Add Product",
    editProductTitle: "Edit Product",
    formSubtitle: "Enter price and costs — we calculate profit instantly",
    fName: "Product name",
    fNamePh: "e.g. Wireless Earbuds Pro",
    fSku: "SKU (optional)",
    fSkuPh: "e.g. EAR-001",
    fPrice: "Selling price",
    fCost: "Purchase/product cost",
    fCurrency: "Currency",
    fCurrencyNone: "Not set",
    fSpec: "Quantity / Spec",
    fSpecQty: "Quantity",
    fSpecUnit: "Unit",
    fSpecNone: "Not set",
    fSpecCustom: "Custom unit…",
    fSpecCustomPh: "Type unit name",
    specHint: "Display info only — never affects inventory",
    navAccounts: "Chart of Accounts",
    accountsSubtitle: "The core financial structure of your business accounts",
    addAccount: "Add account",
    editAccount: "Edit account",
    accountCode: "Account number",
    accountName: "Account name",
    accountType: "Account type",
    parentAccount: "Parent account",
    noParent: "None (top-level)",
    accountSubgroup: "Subgroup",
    noSubgroup: "None",
    accountNature: "Normal balance",
    natureDebit: "Debit",
    natureCredit: "Credit",
    accountStatusLabel: "Status",
    statusActive: "Active",
    statusInactive: "Inactive",
    acctActivate: "Activate",
    acctDeactivate: "Deactivate",
    searchAccounts: "Search by code or name…",
    accountCreated: "Account created",
    accountUpdated: "Account updated",
    accountDeleted: "Account deleted",
    systemAccountNote: "Default account — can only be activated or deactivated",
    deleteAccountConfirm: "This account will be permanently deleted. Accounts with journal entries or child accounts cannot be deleted.",
    acctGroup_assets: "Assets",
    acctGroup_liabilities: "Liabilities",
    acctGroup_equity: "Equity",
    acctGroup_revenue: "Revenue",
    acctGroup_cost_of_sales: "Cost of Sales",
    navLedger: "Journal & Statements",
    ledgerTitle: "Journal & Financial Statements",
    ledgerSubtitle: "Journal entries and financial statements derived directly from posted GL entries",
    tabJournal: "Journal",
    tabTrialBalance: "Trial Balance",
    tabIncome: "Income Statement",
    tabBalanceSheet: "Balance Sheet",
    colRef: "Ref #",
    colType: "Type",
    colAccount: "Account",
    colDebit: "Debit",
    colCredit: "Credit",
    colDesc: "Description",
    srcSale: "Sale",
    srcPurchase: "Purchase",
    srcExpense: "Expense",
    srcReturn: "Return",
    kindPosted: "Posted",
    kindReversal: "Reversal",
    backfilledTag: "Historical",
    searchJournal: "Search by ref, description or account...",
    allTypes: "All types",
    colCode: "Code",
    colDebitTotal: "Debit Total",
    colCreditTotal: "Credit Total",
    colNetBalance: "Net Balance",
    tbTotals: "Totals",
    balancedTag: "Balanced",
    unbalancedTag: "Unbalanced",
    isRevenueSection: "Sales Revenue",
    isLessCogs: "(-) Cost of Goods Sold",
    isGrossProfit: "= Gross Profit",
    isLessExpenses: "(-) Operating Expenses",
    isNetIncome: "= Net Income / (Loss)",
    bsCurrentAssets: "Current Assets",
    bsNonCurrentAssets: "Non-Current Assets",
    bsLiabilitiesSection: "Liabilities",
    bsEquitySection: "Equity",
    bsCurrentEarnings: "Current Period Net Income",
    bsTotalAssets: "Total Assets",
    bsTotalLE: "Total Liabilities & Equity",
    bsEquationOk: "Assets = Liabilities + Equity",
    bsEquationBad: "Accounting equation out of balance",
    fromDate: "From date",
    toDate: "To date",
    noJournalEntries: "No journal entries yet",
    forgotLink: "Forgot password?",
    forgotTitle: "Password recovery",
    forgotDesc: "Enter your registered email and we'll send you a reset link",
    forgotSubmit: "Send recovery link",
    forgotSentTitle: "Request sent",
    forgotSentDesc: "If this email is registered in our system, you will receive account recovery instructions shortly.",
    backToLogin: "Back to login",
    resetTitle: "Set a new password",
    resetDesc: "Enter and confirm your new password",
    resetSubmit: "Change password",
    resetSuccess: "Password changed successfully. You can now sign in.",
    resetLinkInvalid: "This link is invalid, expired, or has already been used",
    requestNewLink: "Request a new link",
    tooManyAttempts: "Too many attempts — please try again in an hour",
    passwordTooShort: "Password too short (min 6 characters)",
    colDate: "Date",
    acct_6810: "Utilities", acct_6820: "Shipping", acct_6830: "Packaging", acct_6840: "Maintenance", acct_6850: "Taxes", acct_6890: "Other Expenses",
    importProducts: "Import Products",
    importTitle: "Import products from file",
    importDesc: "Upload an Excel or CSV file, map the columns, then review the preview before committing",
    downloadTemplate: "Download sample template",
    chooseFile: "Choose a file (.xlsx or .csv)",
    columnMapping: "Column mapping",
    noMap: "— ignore —",
    strategyLabel: "Duplicate handling",
    strategySkip: "Add new only (skip duplicates)",
    strategyUpdate: "Update existing products by SKU",
    previewTitle: "Data preview",
    statusNew: "New",
    statusUpdate: "Update",
    statusDuplicate: "Duplicate",
    statusInvalid: "Invalid",
    reasonMissingName: "Missing name",
    reasonInvalidPrice: "Invalid price",
    reasonInvalidQuantity: "Invalid quantity",
    reasonDupFile: "Duplicate in file",
    reasonDupDb: "Already exists",
    commitImport: "Run import",
    importing: "Importing...",
    importDone: "Import complete",
    importSummaryNew: "New products",
    importSummaryUpdate: "To update",
    importSummaryDuplicate: "Duplicates",
    importSummaryInvalid: "Invalid rows",
    importCreated: "created",
    importUpdated: "updated",
    importSkipped: "skipped",
    importFailed: "Import failed",
    rowLabel: "Row",
    fldName: "Product name",
    fldSku: "SKU / Product code",
    fldCategory: "Category",
    fldUnit: "Unit type",
    fldPurchasePrice: "Purchase price",
    fldSellingPrice: "Selling price",
    fldInitialQty: "Initial quantity",
    fldDescription: "Description",
    exportSales: "Export Sales",
    importSales: "Import Sales",
    importSalesTitle: "Import sales from file",
    salesImportDesc: "Every invoice runs through the same manual-sale pipeline — inventory updates and balanced GL entries happen automatically",
    fldInvoiceRef: "Invoice ref",
    fldDate: "Date",
    fldCustomer: "Customer",
    fldProduct: "Product / SKU",
    fldQuantity: "Quantity",
    fldUnitPrice: "Unit price",
    fldPaymentMethod: "Payment method",
    reasonProductNotFound: "Product not found",
    reasonInsufficientStock: "Insufficient stock",
    reasonExistsRef: "Duplicate ref — already imported",
    invoicesCreated: "invoices created",
    rowsImported: "rows imported",
    exportProducts: "Export Products",
    selectAll: "Select all",
    deleteSelected: "Delete selected",
    bulkDeleteDone: "Bulk delete complete",
    bulkDeleteSummary: "Deleted {deleted} and archived {archived}",
    archivedNotice: "Products with transaction history (sales/purchases/returns) were archived instead of deleted to protect the GL and inventory audit trail:",
    qaPurchaseReturn: "Purchase return",
    prTitle: "Purchase Return",
    prDesc: "Return quantities from a purchase invoice to the supplier — valued at the original recorded purchase cost",
    prSelectPurchase: "Select purchase invoice",
    prRefundMethod: "Refund method",
    prReason: "Reason",
    prReturnQty: "Return qty",
    prPurchased: "Purchased",
    prAlreadyReturned: "Already returned",
    prOriginalCost: "Original cost",
    prSubmit: "Submit return",
    prSuccess: "Purchase return recorded — inventory value reversed with a balanced GL entry",
    prBtn: "Return",
    colInvoiceNo: "Invoice #",
    colCustomer: "Customer",
    colTotal: "Total",
    colCogs: "COGS",
    colQtySold: "Qty sold",
    colPerUnit: "Per unit",
    colValue: "Value",
    colShare: "Share %",
    colRevenue: "Revenue",
    colProfit: "Profit",
    colMargin: "Margin %",
    colStock: "Stock",
    colMin: "Min level",
    colReason: "Reason",
    revDist: "Revenue distribution",
    drillRefunds: "Refunds",
    drillCogsNet: "Net COGS",
    drillNetBusiness: "Operating net profit",
    drillEmpty: "No detailed records",
    colProduct: "Product",
    colCost: "Unit cost",
    acctGroup_expenses: "Expenses",
    acct_1000: "Assets", acct_1100: "Cash", acct_1200: "Bank", acct_1300: "Customers (AR)", acct_1400: "Inventory", acct_1500: "Fixed Assets", acct_1600: "Prepaid Expenses",
    acct_2000: "Liabilities", acct_2100: "Suppliers (AP)", acct_2200: "Loans", acct_2300: "Taxes Payable", acct_2400: "Salaries Payable",
    acct_3000: "Equity", acct_3100: "Capital", acct_3200: "Owner Withdrawals", acct_3300: "Retained Earnings",
    acct_4000: "Revenue", acct_4100: "Product Sales", acct_4200: "Service Revenue", acct_4300: "Other Revenue",
    acct_5000: "Cost of Sales", acct_5100: "Cost of Goods Sold", acct_5200: "Purchase Shipping", acct_5300: "Direct Costs",
    acct_6000: "Expenses", acct_6100: "Rent", acct_6200: "Salaries", acct_6300: "Marketing", acct_6400: "Transportation", acct_6500: "Communications", acct_6600: "Commissions", acct_6700: "Bank Expenses",
    errAcctCodeExists: "Account number already exists",
    errAcctSystemDelete: "Default accounts cannot be deleted — deactivate instead",
    errAcctHasChildren: "Account has child accounts — deactivate instead",
    errAcctLinked: "Account has linked journal entries — deactivate instead",
    errAcctSystemEdit: "Default accounts can only be activated or deactivated",
    errAcctParentGroup: "Parent must be in the same account group",
    errAcctParentInactive: "Parent account is inactive",
    errAcctDepth: "Maximum account depth reached",
    errAcctBadSubgroup: "Invalid subgroup for this account group",
    fShipping: "Shipping cost",
    fAds: "Advertising cost",
    fFee: "Payment/platform fee",
    fDiscount: "Discount",
    fOther: "Other costs",
    fQty: "Quantity sold",
    liveTitle: "Live calculation",
    unitCost: "Total cost per unit",
    unitProfit: "Profit per unit",
    totalProfitLabel: "Total profit",
    saveProduct: "Save product",
    saving: "Saving...",
    productSaved: "Product added successfully",
    productUpdated: "Product updated successfully",
    perUnit: "per unit",
    unitsSold: "units sold",
    back: "Back",
    sellingPrice: "Selling Price",
    totalCostsLabel: "Total Costs",
    revenueLabel: "Revenue",
    breakdownTitle: "Cost breakdown (per unit)",
    simTitle: "Price Simulator",
    simDesc: "Try a new price and see the impact instantly",
    simNewPrice: "New price",
    simCurrentPrice: "Current price",
    simCurrentProfit: "Current profit",
    simNewProfit: "New profit",
    simNewMargin: "New margin",
    simDiff: "Difference from current",
    reportsTitle: "Reports",
    reportsSubtitle: "Your product performance summary",
    reportsComingSoon: "Advanced reports (trends & export) are coming soon.",
    settingsTitle: "Settings",
    account: "Account",
    languageLabel: "Language",
    languageDesc: "Choose your interface language — saved automatically",
    demoSection: "Demo Data",
    demoSectionDesc: "8 sample products with varied prices, costs and margins to explore the app",
    backupSection: "Backup",
    backupDesc: "Download a full snapshot of your business data (products, sales, purchases, expenses, chart of accounts and journal entries) as a JSON file to keep safe",
    backupDownload: "Download Backup",
    obTitle: "Account setup",
    obWelcomeTitle: "Welcome to ProfitLens 👋",
    obWelcomeSub: "Let's get your account ready in a few simple steps.",
    obStart: "Start setup",
    obSkipNow: "Skip for now",
    obContinueLater: "Continue later",
    obBack: "Back",
    obBizStep: "Your business info",
    obBizStepSub: "Update your basic company profile — you can change it later in Settings",
    obBizType: "Business type",
    obType_retail: "Retail",
    obType_ecommerce: "E-commerce",
    obType_services: "Services",
    obType_food: "Food & restaurants",
    obType_wholesale: "Wholesale",
    obType_other: "Other",
    obSaveContinue: "Save & continue",
    obProductsStep: "Your products",
    obProductsStepSub: "Add your products to start tracking your real profit",
    obAddProduct: "Add first product",
    obImportProducts: "Import from Excel/CSV",
    obOpeningStep: "Opening balances",
    obOpeningDesc: "The opening balance is optional — it's the cash you have on hand when you start using the system. No journal entries are created automatically; you can set it now or later in Settings.",
    obSetOpening: "Set opening balance",
    obActionStep: "First business action",
    obActionStepSub: "Record your first real transaction and start your ProfitLens journey",
    obFirstSale: "Record first sale",
    obFirstPurchase: "Add first purchase",
    obFirstExpense: "Add first expense",
    obCompleteTitle: "Excellent! 🎉",
    obCompleteSub: "ProfitLens is ready to help you run your business.",
    obChkBusiness: "Business setup",
    obChkProducts: "Products",
    obChkOpening: "Opening balances",
    obChkFirstTx: "First transaction",
    obGoDashboard: "Go to dashboard",
    obResume: "Resume setup",
    obBannerSub: "Complete the remaining steps to get the most out of ProfitLens",
    obTour: "Guided tour",
    obSkipped: "Skipped",
    obDoneStatus: "Done",
    obPendingStatus: "Pending",
    lpHeroTitle: "Know your real profit.",
    lpHeroSub: "ProfitLens helps you manage sales, purchases, inventory, expenses and accounts — giving you a clear view of your business's real profit.",
    lpHeroCta: "Start for free",
    lpHeroCta2: "See how it works",
    lpHeroTrust: "Start with no credit card.",
    lpModulesTitle: "Your entire business in one place",
    lpMod_sales: "Sales",
    lpMod_sales_d: "Record cash or credit invoices and track each invoice's profit in real time.",
    lpMod_purchases: "Purchases",
    lpMod_purchases_d: "Manage supplier purchase invoices, automatically linked to inventory.",
    lpMod_inventory: "Inventory",
    lpMod_inventory_d: "Live quantities with low-stock alerts before you run out.",
    lpMod_cash: "Treasury & Accounts",
    lpMod_cash_d: "Track cash, withdrawals and expected balances daily.",
    lpMod_accounting: "Accounting & Financial Statements",
    lpMod_accounting_d: "Automatic balanced journal entries and always-ready statements.",
    lpMod_reports: "Reports & Analytics",
    lpMod_reports_d: "Profit, sales and inventory reports that reveal the full picture.",
    lpAccTitle: "Your daily operations, connected to accounting automatically",
    lpAccSub: "Every business transaction is instantly reflected in your books — no manual entry.",
    lpAcc1: "Sales and purchases automatically generate balanced journal entries.",
    lpAcc2: "Inventory movements and COGS are tied to actual accounting records.",
    lpAcc3: "Operating expenses are posted to the correct financial accounts.",
    lpAcc4: "Trial Balance, Income Statement and Balance Sheet derive from posted entries.",
    lpAiTitle: "🤖 Financial intelligence that reads your numbers like an expert.",
    lpAiDesc: "Analyze your sales, profits, expenses, inventory and margins — get clear answers and recommendations that help you understand your business and decide with confidence.",
    lpAiTag: "A smart financial assistant with you at every step.",
    lpAiCap1: "AI Financial Assistant",
    lpAiCap2: "Smart Financial Insights",
    lpAiCap3: "Advanced Financial Analytics",
    lpAiCap4: "Most Profitable Products",
    lpAiCap5: "High Sales / Low Profit Analysis",
    lpAiCap6: "Low Margin Alerts & Recommendations",
    lpKpiTitle: "A dashboard that shows you everything",
    lpKpiSub: "Monitor your business KPIs moment by moment from one place — your real numbers, always.",
    lpKpiSales: "Sales",
    lpKpiCogs: "COGS",
    lpKpiGross: "Gross Profit",
    lpKpiNet: "Net Profit",
    lpKpiMargin: "Profit Margin",
    lpKpiInventory: "Inventory Value",
    lpKpiCash: "Cash Balance",
    lpKpiProducts: "Product Profitability",
    lpAudTitle: "Built for business owners",
    lpAud1: "Retail shops",
    lpAud2: "Small businesses",
    lpAud3: "Trading businesses",
    lpAud4: "Wholesale businesses",
    lpAud5: "Service businesses",
    lpHowTitle: "How does ProfitLens work?",
    lpHow1: "Create your account",
    lpHow1d: "Sign up free in under a minute — no credit card needed.",
    lpHow2: "Add your products and business data",
    lpHow2d: "Add products manually or import them in bulk from Excel.",
    lpHow3: "Start selling and managing — know your real profit",
    lpHow3d: "Every transaction is instantly reflected in reports and accounting.",
    lpHowCta: "Start now for free",
    lpPriceTitle: "Simple, transparent pricing",
    lpPriceSub: "Start free and upgrade whenever you need the power of AI.",
    lpPlanFree: "Free Plan",
    lpPlanFreePrice: "Free",
    lpFree1: "Manage products, sales and purchases",
    lpFree2: "Inventory and essential reports",
    lpFree3: "Accounting and financial statements",
    lpFree4: "No credit card required",
    lpPlanPremium: "Premium",
    lpPlanAnnual: "Annual Plan",
    lpAnnualFirstYear: "first year — introductory price",
    lpAnnualRenewal: "$299/year on renewal",
    lpPrem1: "Everything in the Free plan",
    lpPrem2: "AI Financial Assistant",
    lpPrem3: "Smart insights & analytics",
    lpPrem4: "Low margin alerts & recommendations",
    lpBestValue: "Best value",
    lpStartFree: "Start for free",
    lpStartPremium: "Start Premium",
    lpSecTitle: "Security & trust",
    lpSec1: "Secure account authentication",
    lpSec2: "Role-based permissions",
    lpSec3: "Accounting integrity with balanced entries",
    lpSec4: "Full owner backup",
    lpSec5: "Secure payments via PayPal",
    lpFaqTitle: "Frequently asked questions",
    lpFaq1Q: "Is ProfitLens free?",
    lpFaq1A: "Yes — the Free plan includes products, sales, purchases, inventory, accounting and reports. You can upgrade to Premium anytime.",
    lpFaq2Q: "Do I need a credit card to try it?",
    lpFaq2A: "No — you can create your account and start immediately without any credit card.",
    lpFaq3Q: "Does it support sales, purchases and inventory?",
    lpFaq3A: "Yes — ProfitLens manages the full cycle from purchase to sale, with live inventory updates.",
    lpFaq4Q: "Is accounting connected to operations?",
    lpFaq4A: "Yes — every sale, purchase or expense automatically generates a balanced journal entry, and financial statements derive from posted entries.",
    lpFaq5Q: "What's the difference between Free and Premium?",
    lpFaq5A: "Premium adds the AI Financial Assistant, smart insights and advanced analytics, plus low-margin alerts and recommendations.",
    lpFaq6Q: "Is there an AI financial assistant?",
    lpFaq6A: "Yes — the Premium plan includes a smart assistant that analyzes your numbers, answers your questions and gives clear recommendations.",
    lpFaq7Q: "Can I cancel my subscription?",
    lpFaq7A: "Yes — you can cancel anytime from the subscription page inside your account, with no commitments.",
    lpSupportTitle: "Need help? Talk to us",
    lpSupportSub: "Our team is ready to answer your questions and help you get started.",
    lpWhats: "WhatsApp",
    lpEmail: "Email",
    lpFinalTitle: "Ready to know your real profit?",
    lpFinalSub: "Start managing your business with clarity.",
    lpFooterRights: "© ProfitLens — All rights reserved",
    lpLogin: "Sign in",
    pwaOffline: "No internet connection",
    pwaOfflineSub: "Can't reach the server. Syncing resumes when you're back online.",
    pwaUpdateTitle: "A new version of ProfitLens is available",
    pwaUpdateSub: "Refresh to get the latest improvements. Your data is safe.",
    pwaUpdateBtn: "Refresh",
    pwaLater: "Later",
    pwaInstallTitle: "Install ProfitLens",
    pwaInstallSub: "Install the app on your device for quick access and a better experience.",
    pwaInstallBtn: "Install",
    pwaIosTitle: "Add to Home Screen",
    pwaIosStep1: "Tap the Share button in Safari",
    pwaIosStep2: "Scroll down and choose \"Add to Home Screen\"",
    pwaIosStep3: "Tap \"Add\" at the top",
    pwaClose: "Close",
    draftSaving: "Saving…",
    draftSaved: "Saved automatically",
    draftSaveFailed: "Save failed — kept locally, will retry",
    draftRestored: "Latest saved draft restored",
    lpNavFeatures: "Features",
    lpNavPricing: "Pricing",
    lpNavAbout: "About",
    seoHomeTitle: "ProfitLens | Accounting Software for Retail Stores",
    seoHomeDesc: "Manage sales, purchases, inventory, and expenses in one place with ProfitLens. Track your profits and financial reports easily. Start for free.",
    seoFeaturesTitle: "Features | ProfitLens — Sales, Inventory, Accounting, Reports & AI",
    seoFeaturesDesc: "Your entire business in one place: sales, purchases, inventory, treasury, accounting, financial statements, reports and a smart AI assistant.",
    seoPricingTitle: "Pricing | ProfitLens — Free plan & Premium at $29/month",
    seoPricingDesc: "Start free with no credit card. Premium at $29/month or $99 for the first year — AI financial assistant, advanced analytics and margin alerts.",
    seoAboutTitle: "About | ProfitLens — Smart business management",
    seoAboutDesc: "ProfitLens was built to give small business owners a clear view of their real profit — operations, automatic accounting and financial intelligence in one place.",
    seoAuthTitle: "Sign in or create an account | ProfitLens",
    seoAuthDesc: "Sign in to your ProfitLens account or create one for free and start managing your business.",
    notFoundTitle: "Page not found",
    notFoundDesc: "The link you're trying to reach doesn't exist or has been moved.",
    notFoundHome: "Back to homepage",
    aboutHeroTitle: "ProfitLens was born from a simple idea",
    aboutP1: "A small business owner deserves to know their real profit — not an estimate or a guess, but a precise number derived from every sale, purchase and expense they record.",
    aboutP2: "We built ProfitLens to bring daily operations, automatic accounting and financial intelligence together in one simple system, Arabic-first, at prices small businesses can afford.",
    costUnavailable: "Cost unavailable",
    dangerZone: "Danger Zone",
    deleteAllData: "Delete all company data",
    deleteAllDataDesc: "Permanently deletes all sales, purchases, products, inventory, expenses, treasury, partners, journal entries and all operational data. Your account, subscription and settings remain intact.",
    dangerBackupHint: "We recommend downloading a backup from the Backup section above first.",
    dangerModalTitle: "Warning: permanent deletion of all data",
    dangerModalDesc: "All company operational and accounting data will be permanently deleted. This cannot be undone.",
    dangerPhraseLabel: "To confirm, type this phrase exactly:",
    dangerContinue: "Continue",
    dangerFinalTitle: "Final confirmation",
    dangerFinalDesc: "This is the last step. Are you absolutely sure you want to delete all company data?",
    dangerConfirm: "Yes, delete everything permanently",
    dataDeleted: "All company data deleted — you can start fresh",
    deleting: "Deleting...",
    demoLoaded: "Demo data loaded",
    demoCleared: "Demo data removed",
    requiredBadge: "Required",
    optionalBadge: "Optional",
    requiredSection: "Essentials",
    optionalSection: "Optional costs",
    optionalSectionDesc: "Leave any field empty and it counts as 0 — choose how each cost is entered",
    launchDate: "Sales Start Date",
    launchDateHint: "Optional — when did you start selling this product?",
    createdAtLabel: "Date Added",
    lastUpdated: "Last Updated",
    notSpecified: "Not specified",
    productAge: "Product Age",
    ageToday: "today",
    modeUnit: "Per unit",
    modeTotal: "Total for period",
    modeFixed: "Fixed amount",
    modePercent: "Percentage",
    hintUnit: "e.g. $2 per product",
    hintTotal: "e.g. $100 total for the period",
    hintFixed: "e.g. $1 off per product",
    hintPercent: "e.g. 10% of selling price",
    totalModeNote: "{total} total ÷ {qty} units",
    percentNote: "{pct}% of selling price",
    discountTooHigh: "Discount percentage must be between 0 and 100",
    navSales: "Sales",
    navPurchases: "Purchases",
    navInventory: "Inventory",
    navReturns: "Returns",
    navExpenses: "Expenses",
    navCash: "Cash Register",
    navEmployees: "Employees",
    navPartners: "Partners",
    navAudit: "Audit Log",
    quickActions: "Quick actions",
    qaAddProduct: "Add product",
    qaNewSale: "Record sale",
    qaNewPurchase: "Add purchase",
    qaNewReturn: "Record return",
    qaAddExpense: "Add expense",
    setupTitle: "Complete your business setup",
    setupDesc: "Business name and base currency — you can change them later in Settings",
    bizName: "Business name",
    bizNamePh: "e.g. Al Noor Store",
    bizCurrency: "Base currency",
    bizTimezone: "Timezone",
    setupSave: "Get started",
    bizSaved: "Business settings saved",
    bizSave: "Save settings",
    roleLabel: "Role",
    roleOwner: "Owner",
    roleManager: "Manager",
    roleEmployee: "Employee",
    roleAccountant: "Accountant",
    salesTitle: "Sales",
    newSale: "Record Sale",
    saleNumber: "Sale #",
    customer: "Customer (optional)",
    customerPh: "Customer name",
    paymentMethod: "Payment method",
    pmCash: "Cash",
    pmCard: "Card",
    pmTransfer: "Transfer",
    pmOther: "Other",
    pmCredit: "Credit",
    itemsLabel: "Items",
    addItem: "Add item",
    selectProduct: "Select product",
    qtyLabel: "Qty",
    unitPriceLabel: "Unit price",
    unitType: "Unit type",
    unitGram: "Gram",
    unitKilogram: "Kilogram",
    unitMilliliter: "Milliliter",
    unitPiece: "Piece",
    unitLiter: "Liter",
    unitMeter: "Meter",
    unitCentimeter: "Centimeter",
    unitBox: "Box",
    unitSet: "Set",
    unitOther: "Other",
    currencyLabel: "Currency",
    curSYP: "Syrian Pound",
    curUSD: "US Dollar",
    curEGP: "Egyptian Pound",
    curEUR: "Euro",
    curAED: "UAE Dirham",
    lineDiscount: "Discount",
    lineTotal: "Total",
    subtotalLabel: "Subtotal",
    grandTotal: "Grand total",
    confirmSale: "Confirm sale",
    editSaleTitle: "Edit sale invoice",
    editPurchaseTitle: "Edit purchase invoice",
    editReturnTitle: "Edit return",
    saveChanges: "Save changes",
    saleUpdated: "Sale invoice updated",
    purchaseUpdated: "Purchase invoice updated",
    returnUpdated: "Return updated",
    editPinTitle: "Protected invoice edit",
    editPinDesc: "Enter the owner PIN to open the edit page",
    editPasswordDesc: "Enter your account password to open the edit page",
    wrongPasswordMsg: "Incorrect password",
    editNoAuthSetup: "Editing is protected — set up a PIN or account password first",
    goToSettings: "Go to Settings",
    countryLabel: "Country",
    detectedCountryHint: "We detected your country automatically: {country} — you can change it anytime",
    dateFormatLabel: "Date format",
    numberFormatLabel: "Number format",
    currencyChangeNote: "Changing the country or currency never converts or modifies previously recorded amounts or invoices — it only affects display and the default currency",
    saleCreated: "Sale recorded successfully",
    saleCancelledMsg: "Sale cancelled",
    cancelSaleBtn: "Cancel sale",
    statusConfirmed: "Confirmed",
    statusCancelled: "Cancelled",
    dateLabel: "Date",
    soldBy: "Sold by",
    cogsLabel: "COGS",
    grossProfitLabel: "Gross profit",
    profitLabel: "Profit",
    noSales: "No sales yet",
    purchasesTitle: "Purchases",
    newPurchase: "Add Purchase",
    purchaseNumber: "Purchase #",
    supplier: "Supplier",
    supplierPh: "Supplier name",
    invoiceNumber: "Invoice number",
    purchaseDate: "Purchase date",
    unitCostLabel: "Unit cost",
    additionalCostsLabel: "Additional costs",
    confirmPurchase: "Confirm purchase",
    purchaseCreated: "Purchase recorded successfully",
    noPurchases: "No purchases yet",
    returnsTitle: "Returns",
    newReturn: "Record Return",
    returnNumber: "Return #",
    originalSale: "Original sale (optional)",
    reasonLabel: "Reason",
    rChangedMind: "Customer changed mind",
    rDamaged: "Damaged",
    rWrongProduct: "Wrong product",
    rDefect: "Defect",
    rOther: "Other",
    restockLabel: "Restock returned items",
    refundTotalLabel: "Refund total",
    refundMethod: "Refund method",
    confirmReturn: "Confirm return",
    returnCreated: "Return recorded successfully",
    noReturns: "No returns yet",
    expensesTitle: "Expenses",
    newExpense: "Add Expense",
    amountLabel: "Amount",
    categoryLabel: "Category",
    descriptionLabel: "Description",
    notesLabel: "Notes",
    cat_rent: "Rent",
    cat_utilities: "Utilities",
    cat_salaries: "Salaries",
    cat_advertising: "Advertising",
    cat_shipping: "Shipping",
    cat_packaging: "Packaging",
    cat_maintenance: "Maintenance",
    cat_transportation: "Transportation",
    cat_taxes: "Taxes",
    cat_other: "Other",
    expenseCreated: "Expense added",
    expenseUpdated: "Expense updated",
    expenseDeleted: "Expense deleted",
    noExpenses: "No expenses yet",
    editExpense: "Edit expense",
    inventoryTitle: "Inventory",
    currentStock: "Current stock",
    minStockLabel: "Min level",
    stockStatus: "Status",
    stOk: "OK",
    stLow: "Low",
    stOut: "Out",
    lowStockTitle: "Low-stock products",
    recentMovements: "Recent movements",
    movementType: "Type",
    mv_PURCHASE: "Purchase",
    mv_SALE: "Sale",
    mv_RETURN: "Return",
    mv_ADJUSTMENT: "Adjustment",
    mv_DAMAGE: "Damage",
    mv_MANUAL_CORRECTION: "Manual correction",
    adjustStock: "Adjust stock",
    adjustQty: "Quantity (+ add / − remove)",
    referenceLabel: "Reference",
    byLabel: "By",
    inventoryValue: "Inventory value",
    movementAdded: "Inventory movement added",
    qtyChange: "Change",
    cashTitle: "Cash Register",
    openingBalance: "Opening balance",
    cashSalesLabel: "Cash sales",
    cashRefundsLabel: "Cash refunds",
    cashExpensesLabel: "Cash expenses",
    cashWithdrawalsLabel: "Cash withdrawals",
    cashBalance: "Current balance",
    expectedCash: "Expected cash",
    actualCash: "Actual cash",
    differenceLabel: "Difference",
    dailyClosing: "Daily closing",
    closingSaved: "Closing recorded",
    closingsHistory: "Closings history",
    withdrawalsTitle: "Withdrawals",
    newWithdrawal: "Record withdrawal",
    personLabel: "Person",
    personPh: "Person name",
    sourceLabel: "Source",
    srcCash: "Cash",
    srcBank: "Bank",
    withdrawalCreated: "Withdrawal recorded",
    noWithdrawals: "No withdrawals",
    noClosings: "No closings yet",
    employeesTitle: "Employees",
    addEmployee: "Add Employee",
    phoneLabel: "Phone",
    salaryLabel: "Salary",
    commissionLabel: "Commission",
    hireDateLabel: "Hire date",
    statusLabel: "Status",
    statusActive: "Active",
    statusInactive: "Inactive",
    permissionsTitle: "Permissions",
    editPermissions: "Edit permissions",
    employeeCreated: "Employee added",
    employeeUpdated: "Employee updated",
    permissionsUpdated: "Permissions updated",
    passwordLabel: "Password",
    editEmployee: "Edit employee",
    partnersTitle: "Partners",
    addPartner: "Add Partner",
    ownershipLabel: "Ownership %",
    partnerCreated: "Partner added",
    txnType: "Transaction type",
    ttAllocation: "Profit allocation",
    ttWithdrawal: "Withdrawal",
    ttContribution: "Contribution",
    balanceLabel: "Balance",
    addTransaction: "Add transaction",
    txnCreated: "Transaction added",
    transactionsLabel: "Transactions",
    noPartners: "No partners yet",
    noTxns: "No transactions",
    repSales: "Sales report",
    repPurchases: "Purchases report",
    repInventory: "Inventory report",
    repReturns: "Returns report",
    repExpenses: "Expenses report",
    repProfit: "Profit report",
    repCash: "Cash report",
    reportType: "Report type",
    rangeToday: "Today",
    range7: "Last 7 days",
    range30: "Last 30 days",
    rangeMonth: "This month",
    rangeLastMonth: "Last month",
    rangeYear: "This year",
    rangeCustom: "Custom range",
    fromLabel: "From date",
    toLabel: "To date",
    viewReport: "View report",
    selectBothDates: "Select both start and end dates",
    netRevenue: "Net revenue",
    opExpenses: "Operating expenses",
    refundsLabel: "Refunds",
    grossMarginLabel: "Gross margin",
    netMarginLabel: "Net margin",
    auditTitle: "Audit Log",
    actionLabel: "Action",
    entityLabel: "Entity",
    summaryLabel: "Details",
    timeLabel: "Time",
    noAudit: "No entries yet",
    statInventoryValue: "Inventory value",
    statCash: "Cash balance",
    statLowStock: "Low stock",
    statReturns: "Returns",
    statExpenses: "Operating expenses",
    statCogs: "COGS",
    statGrossProfit: "Gross profit",
    businessSection: "Business",
    allowNegStock: "Allow negative stock",
    viewAudit: "View audit log",
    noPermission: "You don't have permission to access this page",
    stockCol: "Stock",
    minStockField: "Minimum stock level",
    minStockHint: "Get alerted when stock falls to this level",
    perm_products_view: "View products",
    perm_products_manage: "Manage products",
    perm_finance_view: "View costs & profits",
    perm_inventory_view: "View inventory",
    perm_inventory_adjust: "Adjust inventory",
    perm_purchases_view: "View purchases",
    perm_purchases_manage: "Manage purchases",
    perm_sales_view: "View sales",
    perm_sales_create: "Record sales",
    perm_sales_cancel: "Cancel sales",
    perm_returns_view: "View returns",
    perm_returns_manage: "Manage returns",
    perm_expenses_view: "View expenses",
    perm_expenses_manage: "Manage expenses",
    perm_cash_view: "View cash register",
    perm_cash_close: "Close cash register",
    perm_withdrawals_view: "View withdrawals",
    perm_withdrawals_manage: "Record withdrawals",
    perm_employees_view: "View employees",
    perm_employees_manage: "Manage employees",
    perm_partners_view: "View partners",
    perm_partners_manage: "Manage partners",
    perm_reports_view: "View reports",
    perm_reports_financial: "Financial reports",
    perm_audit_view: "Audit log",
    perm_settings_manage: "Business settings",
    greeting: "Hello {name} 👋",
    lockTitle: "Session locked",
    lockDesc: "Enter your password or PIN to continue",
    unlockBtn: "Unlock",
    unlockFailed: "Invalid credentials",
    unlockWithPassword: "Unlock with password",
    unlockWithPin: "Unlock with PIN",
    pinSection: "Owner PIN",
    pinDesc: "A numeric PIN (4-8 digits) protecting sensitive sections like profit, partners and cash",
    pinEnter: "Enter PIN",
    pinSaved: "PIN saved",
    pinClearedMsg: "PIN removed",
    pinClear: "Remove PIN",
    pinWrong: "Incorrect PIN",
    pinRequiredTitle: "PIN-protected section",
    pinRequiredDesc: "Enter the owner PIN to continue",
    pinUnlock: "Unlock with PIN",
    pinEnabledLabel: "Enabled",
    pinDisabledLabel: "Disabled",
    lockTimeout: "Auto-lock after inactivity",
    lockOff: "Off",
    lockMinutes: "{n} minutes",
    usersPermsLink: "Users & Permissions",
    cancelPurchase: "Cancel purchase",
    purchaseCancelled: "Purchase cancelled",
    cancelReturn: "Cancel return",
    returnCancelled: "Return cancelled",
    statusToggle: "Enable / disable",
    employeeStatusUpdated: "Employee status updated",
    perm_products_view: "View products",
    perm_products_create: "Create products",
    perm_products_edit: "Edit products",
    perm_products_delete: "Delete products",
    perm_products_costs: "View product costs",
    perm_sales_view: "View sales",
    perm_sales_create: "Create sales",
    perm_sales_edit: "Edit sales",
    perm_sales_cancel: "Cancel sales",
    perm_purchases_view: "View purchases",
    perm_purchases_create: "Create purchases",
    perm_purchases_edit: "Edit purchases",
    perm_purchases_cancel: "Cancel purchases",
    perm_inventory_view: "View inventory",
    perm_inventory_adjust: "Adjust inventory",
    perm_returns_view: "View returns",
    perm_returns_create: "Create returns",
    perm_returns_edit: "Edit returns",
    perm_returns_cancel: "Cancel returns",
    perm_expenses_view: "View expenses",
    perm_expenses_create: "Create expenses",
    perm_expenses_edit: "Edit expenses",
    perm_expenses_delete: "Delete expenses",
    perm_finance_profit: "View profit",
    perm_finance_margin: "View profit margin",
    perm_finance_reports: "Financial reports",
    perm_cash_view: "View cash register",
    perm_cash_close: "Close cash register",
    perm_salaries_view: "View salaries",
    perm_withdrawals_view: "View withdrawals",
    perm_withdrawals_manage: "Record withdrawals",
    perm_employees_view: "View employees",
    perm_employees_manage: "Manage employees",
    perm_partners_view: "View partners",
    perm_partners_manage: "Manage partners",
    perm_users_manage: "Manage users",
    perm_permissions_manage: "Manage permissions",
    perm_settings_business: "Business settings",
    perm_audit_view: "Audit log",
    kioskTitle: "Who is using the system?",
    kioskSelect: "Select your name to continue",
    kioskPasswordFor: "Enter your password",
    kioskContinue: "Continue",
    kioskWrong: "Incorrect password or PIN",
    switchUser: "Switch user",
    usernameLabel: "Username / code",
    usernameHint: "Optional — used to log in without an email. Auto-generated if left empty",
    kioskLoginLink: "Sign in with employee code",
    emailLoginLink: "Sign in with email",
    kioskLoginTitle: "Employee sign in",
    kioskLoginSubtitle: "Enter your username/code and password",
    setupPasswordTitle: "First-time password setup",
    setupPasswordDesc: "No password is set for {name} yet. Create a new password to continue.",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    passwordMismatch: "Passwords do not match",
    passwordSetSuccess: "Password set successfully",
    setupPasswordLink: "Create a new password",
    setupOwnerPin: "Owner PIN",
    passwordOptionalHint: "Optional — if left empty, the employee creates their own password on first login",
    ownerSetupTitle: "Owner account setup",
    ownerSetupSubtitle: "Choose the username and password for your main account",
    emailOrUsername: "Email or username",
    setupSaveBtn: "Save & start",
    aiAssistant: "AI Financial Assistant",
    aiSubtitle: "Ask about your sales, profit and inventory — answers from your real data",
    aiPlaceholder: "Type your financial question...",
    aiNewChat: "New chat",
    aiThinking: "Thinking...",
    aiError: "Assistant unavailable, please try again",
    aiEmpty: "Start with a question or pick a quick action below",
    qaDaily: "Daily Summary",
    qaSales: "Sales Report",
    qaProfit: "Profit Report",
    qaExpenses: "Expenses Report",
    qaInventory: "Inventory Report",
    qaFull: "Full Financial Report",
    qaDailyPrompt: "Give me today's summary: sales, expenses and net profit today with a quick comparison to the last 7 days",
    qaSalesPrompt: "Give me the sales report for the last 30 days: revenue, number of sales, and top products in a table",
    qaProfitPrompt: "Give me the profit report for the last 30 days: revenue, COGS, net profit and margin per currency",
    qaExpensesPrompt: "Give me the expenses report for the last 30 days: total and breakdown by category in a table",
    qaInventoryPrompt: "Give me the inventory report: product stock status and low-stock items that need reordering",
    qaFullPrompt: "Give me a full financial report: sales, purchases, expenses and profit for the last 30 days with low-stock alerts and a monthly comparison",
    navSubscription: "Subscription",
    subTitle: "Subscription Management",
    subSubtitle: "Your company's AI Financial Assistant subscription",
    subStatus: "Subscription status",
    subTrial: "Free trial",
    subActive: "Active subscription",
    subExpired: "Expired",
    subTrialEnds: "Trial expiration date",
    subDaysRemaining: "Days remaining",
    subActiveSince: "Active since",
    subPlanTitle: "AI Financial Assistant plan",
    subFeature1: "Instant answers about sales, profit and inventory from your real data",
    subFeature2: "Daily and monthly reports with period comparisons",
    subFeature3: "Low-stock alerts and product profitability analysis",
    subFeature4: "Direct lookup of any invoice, customer, or supplier",
    subUpgrade: "Upgrade subscription",
    subUpgradeNote: "Secure payment via PayPal — features activate only after payment confirmation",
    subActivated: "Subscription activated successfully",
    subState_free: "Free",
    subState_trial: "Trial",
    subState_active: "Active",
    subState_pending_payment: "Pending payment",
    subState_past_due: "Past due",
    subState_cancellation_scheduled: "Cancellation scheduled",
    subState_expired: "Expired",
    subPlan: "Plan",
    subCurrentPeriod: "Current billing period",
    subNextRenewal: "Next renewal",
    subEndsOn: "Ends on",
    subPaymentStatus: "Payment status",
    subCancelBtn: "Cancel subscription",
    subCancelTitle: "Cancel subscription",
    subCancelConfirm: "Premium features stay active until the end of your paid billing cycle on {date}, then your account downgrades to the Free plan. No data, invoices, or financial records will be deleted or changed.",
    subCancelKeep: "Keep subscription",
    subCancelConfirmBtn: "Confirm cancellation",
    subCancelScheduled: "Cancellation scheduled — access continues until the paid cycle ends",
    subCancelledNote: "Cancellation scheduled — access continues until {date}",
    subReactivate: "Reactivate subscription",
    subReactivated: "Your subscription has been reactivated",
    subPendingTitle: "Processing payment…",
    subPendingDesc: "We're verifying your payment with PayPal — this can take a minute",
    subRefresh: "Refresh status",
    subPastDueDesc: "Your last renewal payment failed — access continues until the cycle ends; update your payment method in PayPal",
    subHistoryTitle: "Payment history",
    subHistoryEmpty: "No payments yet",
    yearlyComingSoon: "Coming soon",
    subPaypalUnavailable: "Payment gateway is not configured yet — contact support",
    subState_unverified: "Unverified",
    subUnverifiedDesc: "This subscription is not linked to a verified PayPal subscription. Please subscribe again to activate PayPal billing.",
    subNotLinkedMsg: "This subscription is not linked to a verified PayPal subscription. Please subscribe again to activate PayPal billing.",
    subCurrentPlan: "Current Plan",
    subPlansTitle: "Plans",
    subSwitchNote: "To switch plans: cancel your current subscription first, then subscribe to the new plan to avoid double billing",
    subStartDate: "Start date",
    subBillingInterval: "Billing interval",
    subIntervalMonth: "Monthly",
    subIntervalYear: "Yearly",
    subAutoRenew: "Auto-renew",
    subAutoOn: "On",
    subAutoOff: "Off",
    subPaypalId: "PayPal subscription ID",
    heroBadge: "Take your business to the next level 🚀",
    heroTitle: "Choose the right plan for you",
    heroSubtitle: "Get all the tools you need to run your business and track your true profits",
    monthlyDesc: "Full flexibility, no long-term commitment",
    annualFirstYear: "First year, then $299/year on renewal",
    bestSaver: "Best value",
    saveUpTo: "Save up to 67%",
    compareTitle: "Plan comparison",
    colFeature: "Feature",
    compAI: "AI Financial Assistant",
    compInsights: "Smart recommendations & alerts",
    compProfit: "Advanced profit analytics",
    compReports: "Detailed profit reports",
    compPrice: "Price",
    compSavings: "Yearly savings",
    compMonthlyPrice: "$29 / month",
    compAnnualPrice: "$99 first year",
    compSaveNone: "—",
    compSave67: "Up to 67%",
    trustSecure: "Secure PayPal payments",
    trustCancel: "Cancel anytime",
    trustSupport: "Premium support",
    trustSetup: "Quick setup",
    helpTitle: "Need help choosing a plan?",
    helpDesc: "Our team is ready to help you pick the right plan for your business size",
    helpCta: "Contact us",
    whatsappSupport: "WhatsApp",
    emailSupport: "Email",
    helpToast: "Direct contact is coming soon — all plan details are in the comparison table above",
    colAmount: "Amount",
    colStatus: "Status",
    pay_completed: "Completed",
    pay_pending: "Pending",
    pay_cancel_scheduled: "Cancel scheduled",
    pay_reactivated: "Reactivated",
    subBadgeActive: "Active",
    subPillActive: "PREMIUM · ACTIVE",
    subPillTrial: "PREMIUM · FREE TRIAL · {days}d left",
    subBadgeTrial: "Free trial — {days} days left",
    subBadgeExpired: "Trial expired",
    aiLockedTitle: "Your AI Assistant free trial has ended",
    aiLockedDesc: "The rest of ProfitLens keeps working normally. Activate the subscription to keep using the AI Financial Assistant.",
    aiContactOwner: "Contact the account owner to activate the subscription",
    premiumBadge: "Premium",
    premiumLockedTitle: "Premium feature",
    premiumLockedDesc: "Smart analytics, financial recommendations and advanced profit reports require a Premium subscription. The rest of ProfitLens keeps working normally.",
    premiumAnalyticsTitle: "Smart financial analytics — Premium feature",
    upgradeNow: "Upgrade to Premium",
    choosePlan: "Choose your plan",
    planMonthly: "Monthly plan",
    planYearly: "Yearly plan",
    perMonth: "per month",
    perYear: "per year",
    bestValue: "Best value — save 72%",
    launchOfferNote: "Launch offer: $99 for the first year only, then $299/year",
    renewalNote: "Renews after the first year at ${price}/year",
    freeFeaturesTitle: "Always free",
    premiumFeaturesTitle: "Premium features",
    freeF1: "Sales & Purchases",
    freeF2: "Inventory management",
    freeF3: "Expenses, customers & suppliers",
    freeF4: "Basic reports",
    premF1: "AI Financial Assistant",
    premF2: "Most profitable products analysis",
    premF3: "Lowest profit margin analysis",
    premF4: "High / low profit sales analysis",
    premF5: "Smart insights, recommendations & alerts",
    premF6: "Margin & pricing recommendations",
    subActivePlan: "Your subscription is active — {plan}",
    loading: "Loading...",
    member: "ProfitLens member",
    productsCount: "products",
  },
};

export const SPEC_UNITS = ["piece", "gram", "kilogram", "liter", "milliliter", "meter", "centimeter", "box", "set", "other"];

const SPEC_UNIT_KEYS = {
  piece: "unitPiece",
  gram: "unitGram",
  kilogram: "unitKilogram",
  liter: "unitLiter",
  milliliter: "unitMilliliter",
  meter: "unitMeter",
  centimeter: "unitCentimeter",
  box: "unitBox",
  set: "unitSet",
  other: "unitOther",
};

export function specUnitLabel(unit, t) {
  if (!unit) return "";
  const key = SPEC_UNIT_KEYS[unit];
  return key ? t(key) : unit;
}

export function specLabel(p, t) {
  const qty = p?.spec_quantity;
  const unit = specUnitLabel(p?.spec_unit, t);
  if (qty == null && !unit) return null;
  return [qty != null ? String(qty) : "", unit].filter(Boolean).join(" ");
}
